
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $9638d45de83d5cf1$export$85fae2512280f40b(theme, lang) {
    if (!("fetch" in window)) return;
    return fetch(`${window.BH_URL}/api/widget-enabled?rootTheme=${theme}&theme=${theme}&lang=${lang}`);
}


var $0e53695f56cec54b$exports = {};
(function(global, factory) {
    $0e53695f56cec54b$exports = factory();
})($0e53695f56cec54b$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});



const $773b60ff9ada0e5d$export$92a206f25e973e57 = `
  <svg
    class="beratungshero--icon"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.498 19.802a.75.75 0 0 1-.996-1.122l18-15.99a.75.75 0 0 1 .996 1.12l-18 15.992zM16.953 8.078a6.966 6.966 0 0 1-1.241 3.055l.824.235C19.19 12.127 20 14.545 20 15.961v1.003A3.04 3.04 0 0 1 16.964 20H3.534l2.11-1.875h11.32c.641 0 1.161-.52 1.161-1.16V15.96a2.902 2.902 0 0 0-2.105-2.79l-1.8-.515a7.013 7.013 0 0 1-4 1.403l6.733-5.98zm-1.141-5.005l-1.418 1.26a5.156 5.156 0 1 0-7.592 6.744l-2.137 1.898-.685.196a2.902 2.902 0 0 0-2.052 2.236l-1.924 1.71A3.071 3.071 0 0 1 0 16.963v-1.003c0-1.446.831-3.84 3.464-4.593l.824-.235a7.01 7.01 0 0 1-1.32-4.102 7.03 7.03 0 0 1 12.844-3.958z"
      fillRule="nonzero"
    />
  </svg>
`;
const $773b60ff9ada0e5d$export$8360e631d277ea4d = `<svg width="10px" height="10px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="CloseWidget" stroke="none" stroke-width="1" fill-rule="evenodd">
        <path d="M10,8.85231025 L18.6292049,0.233566186 C18.9466023,-0.0834464214 19.4572997,-0.0796864741 19.7698794,0.241964263 C20.0824591,0.563615001 20.0785537,1.08135394 19.7611563,1.39836655 L11.1490827,10 L19.7611563,18.6016335 C20.0785537,18.9186461 20.0824591,19.436385 19.7698794,19.7580357 C19.4572997,20.0796865 18.9466023,20.0834464 18.6292049,19.7664338 L10,11.1476898 L1.37079506,19.7664338 C1.05339769,20.0834464 0.54270033,20.0796865 0.230120591,19.7580357 C-0.0824591484,19.436385 -0.0785536815,18.9186461 0.238843695,18.6016335 L8.85091726,10 L0.238843695,1.39836655 C-0.0785536815,1.08135394 -0.0824591484,0.563615001 0.230120591,0.241964263 C0.54270033,-0.0796864741 1.05339769,-0.0834464214 1.37079506,0.233566186 L10,8.85231025 Z" id="Combined-Shape" fill-rule="nonzero"></path>
    </g>
</svg>`;
const $773b60ff9ada0e5d$export$530dccc8e24f4e99 = `
  <svg
    class="beratungshero--icon"
    viewBox="0 0 27 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill-rule="nonzero">
      <path d="M3 17a3 3 0 01-3-3V3a3 3 0 013-3h21a3 3 0 013 3v11a3 3 0 01-3 3H11.362L4 23.135V17H3zm7.638-2H24a1 1 0 001-1V3a1 1 0 00-1-1H3a1 1 0 00-1 1v11a1 1 0 001 1h3v3.865L10.638 15z"/><path d="M6 7h15a1 1 0 000-2H6a1 1 0 100 2zM6 11h8a1 1 0 000-2H6a1 1 0 100 2z"/>
    </g>
  </svg>
`;
const $773b60ff9ada0e5d$export$5f8d3589eb8441ca = `
  <svg class="beratungshero--icon" viewBox="0 0 27 19" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path d="M18.6666667,15.765625 C18.6666667,17.4801384 17.2890255,18.875 15.5833333,18.875 L3.08333333,18.875 C1.37764112,18.875 0,17.4801384 0,15.765625 L0,3.109375 C0,1.39486164 1.37764112,0 3.08333333,0 L15.5833333,0 C17.2890255,0 18.6666667,1.39486164 18.6666667,3.109375 L18.6666667,3.48629515 L21.2060905,0.91512852 C21.7843415,0.329645025 22.5703373,0 23.3907118,0 L23.9166667,0 C25.6223589,0 27,1.39486164 27,3.109375 L27,15.765625 C27,17.4801384 25.6223589,18.875 23.9166667,18.875 L23.3907118,18.875 C22.5703373,18.875 21.7843415,18.545355 21.2060931,17.9598741 L18.6666667,15.3887048 L18.6666667,15.765625 Z M3.08333333,2 C2.48781027,2 2,2.49390789 2,3.109375 L2,15.765625 C2,16.3810921 2.48781027,16.875 3.08333333,16.875 L15.5833333,16.875 C16.1788564,16.875 16.6666667,16.3810921 16.6666667,15.765625 L16.6666667,10.5175452 L22.6290657,16.5544742 C22.8322155,16.7601648 23.106025,16.875 23.3907118,16.875 L23.9166667,16.875 C24.5121897,16.875 25,16.3810921 25,15.765625 L25,3.109375 C25,2.49390789 24.5121897,2 23.9166667,2 L23.3907118,2 C23.106025,2 22.8322155,2.11483516 22.6290631,2.32052841 L16.6666667,8.35745485 L16.6666667,3.109375 C16.6666667,2.49390789 16.1788564,2 15.5833333,2 L3.08333333,2 Z" id="video" fill="#fff" fill-rule="nonzero"></path>
    </g>
  </svg>`;
const $773b60ff9ada0e5d$export$ead18583963a4390 = `
  <svg
      class="beratungshero--icon"
      viewBox="0 0 103 97"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.087 1.456l.13.168 65.35 88.485a4 4 0 01-6.305 4.92l-.131-.167L.783 6.377a4 4 0 016.304-4.92zm95.893 20.938l.013.25.007.366v50c0 7.391-8.39 11.585-14.337 7.244l-.2-.15-.224-.18-10.313-8.594-.02.185a11.999 11.999 0 01-5.317 8.526l-4.775-6.465a4 4 0 002.18-3.345L70 70.01v-15.7L93.3 73.73l.102.083c.614.472 1.513.067 1.593-.692l.006-.11V23.088l-.004-.14-.008-.1c-.098-.666-.846-1.034-1.438-.733l-.102.06-.089.067L70 41.707V26.01a4 4 0 00-3.8-3.995l-.2-.005H29.732l-5.908-8H66c6.016 0 10.998 4.426 11.866 10.2l.04.295.02.183 10.313-8.592c5.677-4.732 14.268-.973 14.741 6.298zM2.453 18.738L8 26.248V70.01a4 4 0 003.8 3.995l.2.005h31.274l5.908 8H12C5.475 82.01.166 76.801.004 70.315L0 70.01v-44c0-2.734.914-5.254 2.453-7.272z"
        fillRule="nonzero"
      />
    </svg>
  `;
const $773b60ff9ada0e5d$export$fe475e7e7b6e281b = `
  <svg class="beratungshero--icon" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 0H2C0.89 0 0 0.89 0 2V14C0 15.1 0.89 16 2 16H7V18H15V16H20C21.1 16 21.99 15.1 21.99 14L22 2C22 0.89 21.1 0 20 0ZM20 14H2V2H20V14ZM15 8L8 12V4L15 8Z" fill="currentColor" />
  </svg>`;
const $773b60ff9ada0e5d$export$c3694a0927aa4b45 = `
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.17641 0L0 2.17761L6.72988 8.9112L6.28225 9.37452H0.108048V18.6409H6.28225L14 26.3629V16.1853L20.452 22.6409C19.4487 23.3977 18.3219 24 17.0871 24.3552V27.5367C19.1555 27.0734 21.054 26.1158 22.6593 24.834L25.8236 28L28 25.8224L2.17641 0ZM10.9129 18.9035L7.5634 15.5521H3.19515V12.4633H7.5634L8.92172 11.1042L10.9129 13.0965V18.9035ZM24.8049 14.0077C24.8049 15.2741 24.5733 16.4942 24.172 17.6216L26.5336 19.9846C27.398 18.1776 27.892 16.1544 27.892 14.0077C27.892 7.39768 23.2767 1.86873 17.0871 0.46332V3.64479C21.548 4.97297 24.8049 9.11197 24.8049 14.0077ZM14 1.65251L11.0981 4.55598L14 7.45946V1.65251ZM20.946 14.0077C20.946 11.2741 19.3716 8.92664 17.0871 7.78378V10.5483L20.9151 14.3784C20.9305 14.2548 20.946 14.1313 20.946 14.0077Z" fill="white"/>
  </svg>`;
const $773b60ff9ada0e5d$export$d658018a9147579e = `
  <svg class="beratungshero--icon" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5C0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z" fill="currentColor" />
  </svg>`;
const $773b60ff9ada0e5d$export$9d7c7e61b1dce3b0 = `
  <svg class="beratungshero--icon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 4.5L15 8.5V5C15 4.45 14.55 4 14 4H7.82L19 15.18V4.5ZM1.27 0L0 1.27L2.73 4H2C1.45 4 1 4.45 1 5V15C1 15.55 1.45 16 2 16H14C14.21 16 14.39 15.92 14.54 15.82L17.73 19L19 17.73L1.27 0Z" fill="currentColor" />
  </svg>`;
const $773b60ff9ada0e5d$export$58ee0ea85d7a10b9 = `
  <svg class="beratungshero--icon" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
          <g id="25---Wieder-kontaktieren-1" transform="translate(-262.000000, -370.000000)" fill-rule="nonzero">
              <path d="M276.668192,370.721127 L273.621315,370.01809 C273.28985,369.941596 272.951031,370.113363 272.816939,370.426225 L271.410688,373.707389 C271.287287,373.995331 271.369264,374.330179 271.611723,374.528552 L273.387613,375.981561 C272.333716,378.227901 270.489037,380.09801 268.194768,381.174378 L266.741759,379.398517 C266.543386,379.156057 266.208538,379.07408 265.920596,379.197482 L262.639431,380.603733 C262.326658,380.737766 262.154773,381.076555 262.231296,381.408108 L262.934334,384.454986 C263.0074,384.771597 263.289793,385 263.619442,385 C271.121996,385 277.213202,378.919952 277.213202,371.406235 C277.213202,371.078813 276.987206,370.794721 276.668192,370.721127 Z" id="phone" transform="translate(269.713202, 377.499998) scale(1, -1) rotate(270.000000) translate(-269.713202, -377.499998) "></path>
          </g>
      </g>
  </svg>
  `;
const $773b60ff9ada0e5d$export$56bbcdb8aca31149 = `
  <svg class="beratungshero--icon-calendar" width="16px" height="18px" viewBox="0 0 16 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon/calendar</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">
        <g id="BH-Popup-Variante-D" transform="translate(-28.000000, -375.000000)">
            <g id="Link_Termin" transform="translate(28.000000, 375.000000)">
                <path d="M1.230769,16.7142859 L3.99999979,16.7142859 L3.99999979,13.8214286 L1.230769,13.8214286 L1.230769,16.7142859 Z M4.61538324,16.7142859 L7.6923068,16.7142859 L7.6923068,13.8214286 L4.61538324,13.8214286 L4.61538324,16.7142859 Z M1.230769,13.1785727 L3.99999979,13.1785727 L3.99999979,9.96428634 L1.230769,9.96428634 L1.230769,13.1785727 Z M4.61538324,13.1785727 L7.6923068,13.1785727 L7.6923068,9.96428634 L4.61538324,9.96428634 L4.61538324,13.1785727 Z M1.230769,9.32142732 L3.99999979,9.32142732 L3.99999979,6.42857268 L1.230769,6.42857268 L1.230769,9.32142732 Z M8.3076932,16.7142859 L11.3846168,16.7142859 L11.3846168,13.8214286 L8.3076932,13.8214286 L8.3076932,16.7142859 Z M4.61538324,9.32142732 L7.6923068,9.32142732 L7.6923068,6.42857268 L4.61538324,6.42857268 L4.61538324,9.32142732 Z M11.9999989,16.7142859 L14.7692314,16.7142859 L14.7692314,13.8214286 L11.9999989,13.8214286 L11.9999989,16.7142859 Z M8.3076932,13.1785727 L11.3846168,13.1785727 L11.3846168,9.96428634 L8.3076932,9.96428634 L8.3076932,13.1785727 Z M4.92307854,4.5 L4.92307854,1.60714098 C4.92307854,1.52008683 4.89262631,1.44475463 4.83173025,1.38114 C4.77083419,1.31752098 4.69871712,1.28571366 4.61538324,1.28571366 L3.99999979,1.28571366 C3.91666591,1.28571366 3.84455136,1.31752098 3.78365362,1.38114 C3.72275588,1.44475463 3.69230743,1.52008683 3.69230743,1.60714098 L3.69230743,4.5 C3.69230743,4.58705415 3.72275588,4.66238634 3.78365362,4.72600537 C3.84455136,4.78962 3.91666591,4.82142732 3.99999979,4.82142732 L4.61538324,4.82142732 C4.69871712,4.82142732 4.77083419,4.78962 4.83173025,4.72600537 C4.89262631,4.66238634 4.92307854,4.58705415 4.92307854,4.5 Z M11.9999989,13.1785727 L14.7692314,13.1785727 L14.7692314,9.96428634 L11.9999989,9.96428634 L11.9999989,13.1785727 Z M8.3076932,9.32142732 L11.3846168,9.32142732 L11.3846168,6.42857268 L8.3076932,6.42857268 L8.3076932,9.32142732 Z M11.9999989,9.32142732 L14.7692314,9.32142732 L14.7692314,6.42857268 L11.9999989,6.42857268 L11.9999989,9.32142732 Z M12.30769,4.5 L12.30769,1.60714098 C12.30769,1.52008683 12.277242,1.44475463 12.216346,1.38114 C12.1554499,1.31752098 12.0833328,1.28571366 11.9999989,1.28571366 L11.3846168,1.28571366 C11.3012829,1.28571366 11.2291658,1.31752098 11.1682697,1.38114 C11.1073695,1.44475463 11.0769215,1.52008683 11.0769215,1.60714098 L11.0769215,4.5 C11.0769215,4.58705415 11.1073695,4.66238634 11.1682697,4.72600537 C11.2291658,4.78962 11.3012829,4.82142732 11.3846168,4.82142732 L11.9999989,4.82142732 C12.0833328,4.82142732 12.1554499,4.78962 12.216346,4.72600537 C12.277242,4.66238634 12.30769,4.58705415 12.30769,4.5 Z M16,3.85714098 L16,16.7142859 C16,17.0625016 15.8782037,17.3638379 15.6346152,17.6183036 C15.3910226,17.8727692 15.1025669,18 14.7692314,18 L1.230769,18 C0.897434323,18 0.608975707,17.8727692 0.365384584,17.6183036 C0.121793628,17.3638379 0,17.0625016 0,16.7142859 L0,3.85714098 C0,3.50892878 0.121793628,3.20759122 0.365384584,2.9531239 C0.608975707,2.69866098 0.897434323,2.57142732 1.230769,2.57142732 L2.46153843,2.57142732 L2.46153843,1.60714098 C2.46153843,1.16517512 2.61217779,0.786832683 2.91346156,0.472096098 C3.21474492,0.157363902 3.57692096,0 4,0 L4.61538324,0 C5.03846165,0 5.4006398,0.157363902 5.70192189,0.472096098 C6.00320818,0.786832683 6.15384712,1.16517512 6.15384712,1.60714098 L6.15384712,2.57142732 L9.84615288,2.57142732 L9.84615288,1.60714098 C9.84615288,1.16517512 9.99679182,0.786832683 10.2980781,0.472096098 C10.5993602,0.157363902 10.9615341,0 11.3846168,0 L12,0 C12.4230774,0 12.7852555,0.157363902 13.0865376,0.472096098 C13.3878197,0.786832683 13.5384628,1.16517512 13.5384628,1.60714098 L13.5384628,2.57142732 L14.7692314,2.57142732 C15.1025669,2.57142732 15.3910226,2.69866098 15.6346152,2.9531239 C15.8782037,3.20759122 16,3.50892878 16,3.85714098 Z" id="icon/calendar"></path>
            </g>
        </g>
    </g>
    </svg>`;
const $773b60ff9ada0e5d$export$a80b3bd66acc52ff = `
  <svg class="beratungshero--icon-info" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon/info</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">
        <g id="BH-Popup-Variante-D" transform="translate(-193.000000, -375.000000)" fill-rule="nonzero">
            <g id="Group" transform="translate(193.000000, 375.000000)">
                <path d="M9,0 C13.9696364,0 18,4.03036364 18,9 C18,13.9696364 13.9696364,18 9,18 C4.02872728,18 0,13.9696364 0,9 C0,4.03036364 4.02872728,0 9,0 Z M9,1.8 C5.02345554,1.8 1.8,5.0238604 1.8,9 C1.8,12.9761396 5.02345554,16.2 9,16.2 C12.8943907,16.2 16.0680759,13.1057921 16.1959921,9.24243998 L16.2,9 C16.2,5.02447619 12.9755238,1.8 9,1.8 Z M9,7.2 C9.49705623,7.2 9.9,7.60294372 9.9,8.1 L9.9,8.1 L9.9,12.6 C9.9,13.0970562 9.49705623,13.5 9,13.5 C8.50294373,13.5 8.1,13.0970562 8.1,12.6 L8.1,12.6 L8.1,9 L7.82072753,9 C7.32367126,9 6.92072753,8.59705627 6.92072753,8.1 C6.92072753,7.60294372 7.32367126,7.2 7.82072753,7.2 L7.82072753,7.2 Z M9,4.5 C9.49705627,4.5 9.9,4.90294373 9.9,5.4 C9.9,5.89705627 9.49705627,6.3 9,6.3 C8.50294373,6.3 8.1,5.89705627 8.1,5.4 C8.1,4.90294373 8.50294373,4.5 9,4.5 Z" id="icon/info"></path>
            </g>
        </g>
    </g>
  </svg>`;


function $330d32d652193a23$export$99418391c9d4edd1(url, lang) {
    let regex = new RegExp(`\/${lang}$`);
    return url.match(regex);
}
function $330d32d652193a23$export$47b4274c3eda8f60(url) {
    return url.match(/\/(wishlist)/);
}
function $330d32d652193a23$export$fe63f8185eda093c(url) {
    return url.match(/\/(cart)/);
}
function $330d32d652193a23$export$22de9b359d32fa7a(url) {
    return url.match(/\/c\//);
}
function $330d32d652193a23$export$2fe592674bd7862e(url) {
    return url.match(/\/cp\//);
}
function $330d32d652193a23$export$a6ee0f0139d9689a(url) {
    return url.match(/\/p\//);
}
function $330d32d652193a23$export$3ee1ac535276712(url) {
    return url.match(/\/account\//);
}
function $330d32d652193a23$export$ab20bca5abfae9b7(url) {
    return url.match(/\/cp\/apple-mac-configurator/) || url.match(/\/cp\/produktfinder-cto/);
}
function $330d32d652193a23$export$92413a7c60d15e8a(url, category) {
    if ($330d32d652193a23$export$a6ee0f0139d9689a(url) && window.dataLayer) {
        const dataLayer = [
            ...window.dataLayer
        ].reverse();
        for (const item of dataLayer)if (item.ecommerce && item.ecommerce.detail && item.ecommerce.detail.products && item.ecommerce.detail.products[0] && item.ecommerce.detail.products[0].category) {
            const categoryUrl = item.ecommerce.detail.products[0].category;
            return categoryUrl.match(`/${category}`);
        }
    }
    return false;
}
function $330d32d652193a23$export$e8085726a03718aa(productArray) {
    try {
        if (!window.dataLayer) return null; // if no dataLayer array is found
        // Get a reversed copy of the dataLayer array
        const dataLayer = [
            ...window.dataLayer
        ].reverse();
        // Find the element that contains the pgc attribute
        const foundElement = dataLayer.find((item)=>item.hasOwnProperty("pgc"));
        if (!foundElement) return null; // if no element with pgc attribute is found
        // Check if any value in the "pgc" array matches any element in the provided array
        const isMatch = foundElement.pgc.some((value)=>productArray.includes(value));
        if (isMatch) return foundElement; // returns the matched element if a match is found
        else return null; // returns null if no match in the "pgc" array
    } catch (e) {
        console.error(e);
        return null;
    }
}
function $330d32d652193a23$export$8bcfff33a6c98fa4(url, categories) {
    for (const category of categories){
        if ($330d32d652193a23$export$92413a7c60d15e8a(url, category)) return true;
    }
    return false;
}


function $bd64aa99694b6ef2$export$5c069c93d2b7493f(ms) {
    return new Promise((resolve, reject)=>{
        setTimeout(()=>resolve(), ms);
    });
}
async function $bd64aa99694b6ef2$export$d16800b7e59a8051(selector, tries = 0, ms = 200) {
    if (tries > 20) return null;
    const el = document.querySelector(selector);
    if (el) return el;
    await $bd64aa99694b6ef2$export$5c069c93d2b7493f(ms);
    return $bd64aa99694b6ef2$export$d16800b7e59a8051(selector, tries + 1, ms);
}
async function $bd64aa99694b6ef2$export$73eac51a39d6b0eb(selector, tries = 0, ms = 200) {
    if (tries > 10) return null;
    const elements = document.querySelectorAll(selector);
    if (elements && elements.length > 0) return elements;
    await $bd64aa99694b6ef2$export$5c069c93d2b7493f(ms);
    return $bd64aa99694b6ef2$export$73eac51a39d6b0eb(selector, tries + 1, ms);
}
function $bd64aa99694b6ef2$export$5009e7f3fa7b4cd3(eventName) {
    if (window.hj !== undefined) window.hj("event", eventName);
}
function $bd64aa99694b6ef2$export$4ddbf94935bfdfed(url, ...parameter) {
    const urlParams = new URLSearchParams(url.split("?")[1] || "");
    for (const param of parameter)if (urlParams.has(param[0])) {
        if (new URLSearchParams(param.join("=")).get(param[0]) === urlParams.get(param[0])) return true;
    }
    return false;
}
function $bd64aa99694b6ef2$export$ff4971933d756b02(url, ...paths) {
    for (const path of paths){
        if (path.test(url)) return true;
    }
    return false;
}
function $bd64aa99694b6ef2$export$bfb231a5a6aca5de(theme) {
    const url = document.location.href.split("#")[0];
    if (theme === "micasa") {
        const parameterAndValuePairs = [
            [
                "q",
                "aktion"
            ],
            [
                "q",
                "action"
            ],
            [
                "q",
                "azione"
            ],
            [
                "q",
                "sale"
            ]
        ];
        if ($bd64aa99694b6ef2$export$4ddbf94935bfdfed(url, ...parameterAndValuePairs)) return true;
        const urlRegex = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i,
            /.+\/de\/cp\/sale[\/|\?]?.*$/i,
            /.+\/fr\/cp\/sale[\/|\?]?.*$/i,
            /.+\/it\/cp\/sale[\/|\?]?.*$/i
        ];
        if ($bd64aa99694b6ef2$export$ff4971933d756b02(url, ...urlRegex)) return true;
    } else if (theme === "sportxx" || theme === "sportx") {
        const parameterAndValuePairs = [
            [
                "q",
                "sale"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($bd64aa99694b6ef2$export$4ddbf94935bfdfed(url, ...parameterAndValuePairs)) return true;
        const urlRegex = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i
        ];
        if ($bd64aa99694b6ef2$export$ff4971933d756b02(url, ...urlRegex)) return true;
    } else if (theme === "melectronics") {
        const parameterAndValuePairs = [
            [
                "q",
                "salex"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($bd64aa99694b6ef2$export$4ddbf94935bfdfed(url, ...parameterAndValuePairs)) return true;
        const urlRegex = [
            /.+\/de\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/fr\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/it\/cp\/ausverkauf[\/|\?]?.*$/i,
            /.+\/de\/c\/\d+\/tv-audio\/fernseher[\/|\?]?.*$/i,
            /.+\/fr\/c\/\d+\/tv-audio\/televiseurs[\/|\?]?.*$/i,
            /.+\/it\/c\/\d+\/tv-audio\/televisori[\/|\?]?.*$/i,
            /.+\/de\/c\/\d+\/computing-tablets\/notebooks[\/|\?]?.*$/i,
            /.+\/fr\/c\/\d+\/computing-tablettes\/pc-portable[\/|\?]?.*$/i,
            /.+\/it\/c\/\d+\/computing-tablets\/pc-portatile[\/|\?]?.*$/i
        ];
        if ($bd64aa99694b6ef2$export$ff4971933d756b02(url, ...urlRegex)) return true;
        if ((0, $330d32d652193a23$export$e8085726a03718aa)([
            "Notebooks",
            "Fernseher"
        ])) return true;
    } else if (theme === "doitgarden") {
        const parameterAndValuePairs = [
            [
                "q",
                "%3Arelevance%3Aspecial%3AAktion"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AActions"
            ],
            [
                "q",
                "%3Arelevance%3Aspecial%3AAzioni"
            ]
        ];
        if ($bd64aa99694b6ef2$export$4ddbf94935bfdfed(url, ...parameterAndValuePairs)) return true;
        const urlRegex = [
            /.+\/de\/f\/aktionen[\/|\?]?.*$/i,
            /.+\/fr\/f\/actions[\/|\?]?.*$/i,
            /.+\/it\/f\/azioni[\/|\?]?.*$/i,
            /.+\/de\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/fr\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/it\/cp\/salecoupon[\/|\?]?.*$/i,
            /.+\/de\/outlet[\/|\?]?.*$/i,
            /.+\/fr\/outlet[\/|\?]?.*$/i,
            /.+\/it\/outlet[\/|\?]?.*$/i
        ];
        if ($bd64aa99694b6ef2$export$ff4971933d756b02(url, ...urlRegex)) return true;
    }
    return false;
}


async function $1b115c651245dfe5$export$596743d694fcb1b6({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    var _window_BH, _window, _window_BH1, _window1;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.bannerIsDisabled) return;
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const smartphone = (0, $1a19ad51aa7d708b$export$3c89af888305343f)(url);
    const div = ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_BH1 = _window1.BH) === null || _window_BH1 === void 0 ? void 0 : _window_BH1.newBanner) ? $1b115c651245dfe5$export$759cd82e04668984({
        url: url,
        consultant: consultant,
        theme: theme,
        lang: lang,
        text: smartphone ? texts.mBudget.banner.title : texts.bannerTitle,
        buttonText: `<span>${smartphone ? texts.mBudget.banner.cta : texts.bannerButton}</span>`
    }) : $1b115c651245dfe5$export$477d3f7871bc78f7({
        url: url,
        consultant: consultant,
        theme: theme,
        lang: lang,
        text: smartphone ? texts.mBudget.banner.title : texts.bannerTitle,
        buttonText: `<span>${smartphone ? texts.mBudget.banner.cta : texts.bannerButton}</span>`
    });
    const reviews = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)("#reviews");
    if (reviews) {
        reviews.parentNode.insertBefore(div, reviews);
        $1b115c651245dfe5$export$8e6a1541577e86a7("BUTTON_BANNER_CLICKED");
    }
}
async function $1b115c651245dfe5$export$25c216e52ab8fda1({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    var _window_BH, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.wishlistBannerDisabled) return;
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const banner = $1b115c651245dfe5$var$createBannerDiv({
        url: url,
        consultant: consultant,
        theme: theme,
        lang: lang,
        text: texts.wishlistTitle,
        buttonText: `<span>${texts.wishlistButton}</span>`
    });
    const wishlist = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)(".wishlist.skel--root");
    if (wishlist) {
        const wishlistContainer = document.createElement("div");
        banner.className = "wishlist--container";
        wishlistContainer.appendChild(banner);
        wishlist.appendChild(wishlistContainer);
        $1b115c651245dfe5$export$8e6a1541577e86a7("BUTTON_WISHLIST_CLICKED");
    }
}
async function $1b115c651245dfe5$export$34b442c3d073f811({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const banner = $1b115c651245dfe5$var$createBannerDiv({
        url: url,
        consultant: consultant,
        theme: theme,
        lang: lang,
        text: texts.cartTitle,
        buttonText: `<span>${texts.cartButton}</span>`
    });
    const slider = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)(".p-cart--row__last");
    if (slider) {
        slider.parentNode.insertBefore(banner, slider);
        $1b115c651245dfe5$export$8e6a1541577e86a7("BUTTON_CART_CLICKED");
    }
}
function $1b115c651245dfe5$var$createBannerDiv({ url: url, consultant: consultant, theme: theme, lang: lang, text: text, buttonText: buttonText }) {
    var _window_BH, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.bannerIsDisabled) return;
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    let avatarImage = consultant.imageAvatar;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_240/");
    else avatarImage = window.BH_URL + avatarImage;
    const div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = `
  <div class="beratungshero--banner">
    <div class="beratungshero--avatar-container">
      <img src="${avatarImage}" />
      <div class="beratungshero--avatar-live">${texts.widgetLive}</div>
    </div>
    <div class="beratungshero--body">
      <div class="beratungshero--left">
        <div class="beratungshero--text">
          <div class="beratungshero--title">
            ${text}
          </div>
          <div class="beratungshero-list">
            <div class="beratungshero--list-item">
              ${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${texts.widgetBodyBullet1}
            </div>
          </div>
        </div>
      </div>
      <div class="beratungshero--buttons beratungshero--buttons-center">
        <a id="beratungshero-banner-video" class="beratungshero--more" href="${window.BH_URL}/${theme}/${lang === "en" ? "de" : lang}?connect=auto&url=${encodeURIComponent(url)}&consultantId=${consultant._id}" target="_blank" rel="noopener noreferrer">
      ${buttonText}
    </a>
      </div>
    </div>
  </div>
  `;
    return div;
}
function $1b115c651245dfe5$export$477d3f7871bc78f7({ url: url, consultant: consultant, theme: theme, lang: lang, text: text, buttonText: buttonText }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    let avatarImage = consultant.imageAvatar;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_240/");
    else avatarImage = window.BH_URL + avatarImage;
    const urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(url));
    urlParams.append("consultantId", consultant._id);
    const finalLang = lang === "en" ? "de" : lang;
    const constructedUrl = `${window.BH_URL}/${theme}/${finalLang}?${urlParams.toString()}`;
    const div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = `
  <div class="beratungshero--banner beratungshero--banner--pdp">
    <div class="beratungshero--avatar-container">
      <img src="${avatarImage}" />
      <div class="beratungshero--avatar-live">${texts.widgetLive}</div>
    </div>
    <div class="beratungshero--body beratungshero--body--pdp">
      <div class="beratungshero--left">
        <div class="beratungshero--text">
          <div class="beratungshero--title">
            ${text}
          </div>
          <div class="beratungshero-list">
            <div class="beratungshero--list-item beratungshero--list-item--pdp">
              ${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${texts.widgetBodyBullet1}
            </div>
          </div>
        </div>
      </div>
      <div class="beratungshero--buttons beratungshero--buttons--pdp beratungshero--buttons-center">
        <a id="beratungshero-banner-video" class="beratungshero--more" href="${constructedUrl}" target="_blank" rel="noopener noreferrer">
      ${buttonText}
    </a>
      </div>
    </div>
  </div>
  `;
    return div;
}
function $1b115c651245dfe5$export$759cd82e04668984({ url: url, consultant: consultant, theme: theme, lang: lang, text: text, buttonText: buttonText }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    let image = consultant.imageBranch;
    if (image.indexOf("https://") === 0) image = image.replace("upload/", "upload/w_540/");
    else image = window.BH_URL + image;
    const div = document.createElement("div");
    div.className = "beratungshero-banner-wrapper";
    div.innerHTML = `
  <div class="beratungshero-banner-background"></div>
  <div class="beratungshero-banner">
    <div class="beratungshero-banner__img" style="background-image: url(${image})"></div>
    <div class="beratungshero-banner__content">
      <div class="beratungshero-banner__title">
        Hier und jetzt: unsere Beratung per Video
      </div>
      <div class="beratungshero-banner__list">
        <div class="beratungshero-banner__list__item">
          ${0, $773b60ff9ada0e5d$export$fe475e7e7b6e281b} Video-Beratung aus der Filiale
        </div>
        <div class="beratungshero-banner__list__item">
          ${0, $773b60ff9ada0e5d$export$d658018a9147579e} Wunschprodukte zeigen lassen
        </div>
        <div class="beratungshero-banner__list__item">
          ${0, $773b60ff9ada0e5d$export$9d7c7e61b1dce3b0} Ihr Bild wird nicht \xfcbertragen
        </div>
      </div>
      <a id="beratungshero-banner-video" class="beratungshero-banner__button" href="${window.BH_URL}/${theme}/${lang === "en" ? "de" : lang}?connect=auto&url=${encodeURIComponent(url)}&consultantId=${consultant._id}" target="_blank" rel="noopener noreferrer">
      <div class="beratungshero-banner__button__live">
        <div class="beratungshero-banner__button__live__green-bubble">
        </div>
        LIVE
      </div>
      Video-Beratung starten
    </a>
    </div>
  </div>
  `;
    return div;
}
function $1b115c651245dfe5$export$8e6a1541577e86a7(event) {
    const moreLink = document.querySelector("#beratungshero-banner-video");
    moreLink.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)(event);
    };
}




async function $cf813d967187b691$export$752ff9cccbcd133d({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    var _window_BH, _window, _window_BH1, _window1;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.stickerIsDisabled) return;
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const a = ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_BH1 = _window1.BH) === null || _window_BH1 === void 0 ? void 0 : _window_BH1.newSticker) ? $cf813d967187b691$var$createNewSticker(texts) : $cf813d967187b691$var$createOldSticker(texts, theme);
    const urlParams = new URLSearchParams();
    urlParams.append("url", encodeURIComponent(url));
    urlParams.append("consultantId", consultant._id);
    urlParams.append("source", "sticker");
    const finalLang = lang === "en" ? "de" : lang;
    a.href = `${window.BH_URL}/${theme}/${finalLang}?${urlParams.toString()}`;
    const labelBoxes = await (0, $bd64aa99694b6ef2$export$73eac51a39d6b0eb)(".lNrTChs5SapUD1YBIbMU");
    if (labelBoxes) {
        const labelBox = labelBoxes.length > 1 ? labelBoxes[1] : labelBoxes[0];
        $cf813d967187b691$var$insertSticker(labelBox, a);
    }
}
function $cf813d967187b691$var$createNewSticker() {
    const a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker--new";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = `
  <img class="beratungshero--sticker--new__consultant-image" src="https://res.cloudinary.com/db4fij86r/image/upload/v1631613733/consultants/MicrosoftTeams-image_21_n1mw8k.jpg" alt="consultant image" />
  <img class="beratungshero--sticker--new__consultant-image beratungshero--sticker--new__consultant-image--right" src="https://res.cloudinary.com/db4fij86r/image/upload/v1613570250/consultants/zwnk5rtfbqyjnxqyb7tg.jpg" alt="consultant image" />
  <span>Video-Beratung zum Produkt starten</span>
  <div class="beratungshero--sticker--new__circle">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="white"/>
    </svg>
  </div>
  `;
    return a;
}
function $cf813d967187b691$var$createOldSticker(texts, theme) {
    const a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = `
  <span>${texts.stickerButton[theme] || texts.stickerButton.default}</span>
  <span class="beratungshero--sticker-live">${texts.widgetLive}</span>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
  `;
    return a;
}
function $cf813d967187b691$var$insertSticker(labelBox, a) {
    labelBox.parentNode.insertBefore(a, labelBox);
    (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("STICKER_SHOWN");
    const stickerLink = document.querySelector(".js__beratungshero--sticker");
    if (stickerLink) stickerLink.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_STICKER_CLICKED");
        (0, $bd64aa99694b6ef2$export$5009e7f3fa7b4cd3)("beratungshero_button_sticker_clicked");
    };
    $cf813d967187b691$var$logOptimizeEventStickerShown();
}
function $cf813d967187b691$var$logOptimizeEventStickerShown() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "optimize.macaron.shown"
    });
}


function $e5d437f86f4d95b1$var$getColors(theme) {
    switch(theme){
        case "bikeworld":
            return {
                primary: "#e6000a",
                primaryDark: "#b30008",
                avatarAnimation: "#1d1d1b",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#b30008",
                popupBorder: "1px solid #1d1d1b",
                popupButton: "#fff",
                popupButtonBg: "#e6000a",
                popupClose: "#fff",
                popupCloseBg: "#e6000a",
                stickerBg: "#1d1d1b",
                stickerBgHover: "#1d1d1b",
                widget: "#fff",
                widgetBg: "#1d1d1b",
                widgetBorder: "#1d1d1b",
                nivekiButtonBg: "#1d1d1b"
            };
        case "doitgarden":
            return {
                primary: "#063",
                primaryDark: "#00331a",
                avatarAnimation: "#063",
                popup: "#333",
                popupBg: "#eee",
                popupBgDark: "#00331a",
                popupBorder: "2px solid #063",
                popupButton: "#fff",
                popupButtonBg: "#063",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#00994d"
            };
        case "miocolor":
            return {
                primary: "#f60",
                primaryDark: "#00331a",
                avatarAnimation: "#f60",
                popup: "#333",
                popupBg: "#eee",
                popupBgDark: "#00331a",
                popupBorder: "2px solid #063",
                popupButton: "#fff",
                popupButtonBg: "#063",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#00994d",
                liveBg: "#063"
            };
        case "melectronics":
            return {
                primary: "#015ba7",
                primaryDark: "#163d82",
                avatarAnimation: "#015ba7",
                popup: "#fff",
                popupBg: "#015ba7",
                popupBgDark: "#163d82",
                popupBorder: "1px solid #015ba7",
                popupButton: "#fff",
                popupButtonBg: "#f60",
                popupClose: "#fff",
                popupCloseBg: "#f60",
                nivekiButtonBg: "#0179da"
            };
        case "sportxx":
            return {
                primary: "#640015",
                primaryDark: "#500011",
                avatarAnimation: "#333333",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#1F1F1F",
                popupBorder: "1px solid #333333",
                popupButton: "#fff",
                popupButtonBg: "#640015",
                popupClose: "#fff",
                popupCloseBg: "#640015",
                stickerBg: "#333333",
                stickerBgHover: "#333333",
                widget: "#fff",
                widgetBg: "#333333",
                widgetBorder: "#333333",
                nivekiButtonBg: "#333333"
            };
        case "sportx":
            return {
                primary: "#630015",
                primaryDark: "#191919",
                avatarAnimation: "#f5a29d",
                popup: "#333333",
                popupBg: "#F4F4F4",
                popupBgDark: "#1F1F1F",
                popupBorder: "1px solid #F4F4F4",
                popupButton: "#fff",
                popupButtonBg: "#640015",
                popupClose: "#fff",
                popupCloseBg: "#640015",
                stickerBg: "#333333",
                stickerBgHover: "#333333",
                widget: "#fff",
                widgetBg: "#333333",
                widgetBorder: "#333333",
                nivekiButtonBg: "#333333" // Using sportx.secondaryLight
            };
        case "klubschule":
            return {
                primary: "#0053A6",
                primaryDark: "#00458d",
                avatarAnimation: "#0053A6",
                popup: "#333",
                popupBg: "#f2f2f2",
                popupBgDark: "#00458d",
                popupBorder: "1px solid #0053A6",
                popupButton: "#fff",
                popupButtonBg: "#0053A6",
                popupClose: "#fff",
                popupCloseBg: "#0053A6",
                stickerBg: "#1d1d1b",
                stickerBgHover: "#1d1d1b",
                widget: "#fff",
                widgetBg: "#0053A6",
                widgetBorder: "#0053A6"
            };
        default:
            // micasa
            return {
                primary: "#167f77",
                primaryDark: "#0e544e",
                avatarAnimation: "#167f77",
                popup: "#fff",
                popupBg: "#167f77",
                popupBgDark: "#0e544e",
                popupBorder: "1px solid #167f77",
                popupButton: "#fff",
                popupButtonBg: "#fcb23b",
                popupClose: "#167f77",
                popupCloseBg: "#fff",
                nivekiButtonBg: "#1ea99d"
            };
    }
}
function $e5d437f86f4d95b1$export$31f077b88a3c784c(theme, lang) {
    const { avatarAnimation: avatarAnimation, primary: primary, primaryDark: primaryDark, popup: popup, popupBg: popupBg, popupBorder: popupBorder, popupBgDark: popupBgDark, popupButton: popupButton, popupButtonBg: popupButtonBg, popupClose: popupClose, popupCloseBg: popupCloseBg, popupSolidBg: popupSolidBg, stickerBg: stickerBg, stickerBgHover: stickerBgHover, widget: widget, widgetBg: widgetBg, widgetBorder: widgetBorder, nivekiButtonBg: nivekiButtonBg, liveBg: liveBg, liveBgPopup: liveBgPopup, fontFamily: fontFamily = "inherit" } = $e5d437f86f4d95b1$var$getColors(theme);
    const popupCss = `
    .beratungshero--root {
      box-sizing: border-box;
      color: ${popup};
      font-family: ${fontFamily}
    }

    .beratungshero--root * {
      box-sizing: border-box;
    }

    .beratungshero--button-reset {
      border: none;
      cursor: pointer;
      margin: 0;
      padding: 0;
      width: auto;
      overflow: visible;
      background: transparent;
      color: inherit;
      font: inherit;
      line-height: normal;
      -webkit-font-smoothing: inherit;
      -moz-osx-font-smoothing: inherit;
      -webkit-appearance: none;
    }

    .beratungshero--button-reset:focus {
      outline: none;
    }

    .beratungshero--close {
      align-items: center;
      background-color: ${popupCloseBg};
      border-radius: 50%;
      border: 5px solid ${popupSolidBg || popupBg};
      color: ${popupClose};
      cursor: pointer;
      display: flex;
      height: 30px;
      justify-content: center;
      position: absolute;
      margin-top: -5px;
      margin-right: -5px;
      top: 0;
      right: 0;
      width: 30px;
    }

    .beratungshero--close--mobile {
      align-items: center;
      background-color: ${popupCloseBg};
      border-radius: 50%;
      margin: 5px;
      color: ${popupClose};
      cursor: pointer;
      display: flex;
      height: 24px;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      z-index: 1;
    }

    .beratungshero--close svg {
      fill: currentColor;
    }

    .beratungshero--close--mobile svg {
      fill: currentColor;
    }

    .beratungshero--skew {
      // -moz-transform: skew(20deg, 0deg);
      // -webkit-transform: skew(20deg, 0deg);
      // -o-transform: skew(20deg, 0deg);
      // -ms-transform: skew(20deg, 0deg);
      // transform: skew(20deg, 0deg);
      border-bottom: 110px solid red;
      border-right: 25px solid transparent;
      height: 0;
    }

    .beratungshero--avatar {
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 100;
    }

    .beratungshero--avatar.beratungshero--avatar--multiple1 {
      right: 50px;
    }

    .beratungshero--avatar.beratungshero--avatar--multiple2 {
      right: 21px;
    }

    .beratungshero--avatar.beratungshero--avatar--left {
      left: 10px;
      right: initial;
    }

    .beratungshero--avatar img {
      border-radius: 50%;
      border: 2px solid ${widgetBorder || primary};
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }

    .beratungshero--avatar video {
      border-radius: 50%;
      border: 2px solid #000;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }

    .beratungshero--avatar-img {
      position: relative;
      height: 80px;
      width: 80px;
      margin-left: auto;
      margin-right: auto;
    }

    .beratungshero--avatar-img:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background-color: ${avatarAnimation};
      border-radius: 50%;
      will-change: transform;
    }

    .beratungshero--avatar-img.beratungshero--avatar-pulse:after {
      animation: beratungshero-pulse 2s infinite;
    }

    @keyframes beratungshero-pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(1.2);
        opacity: 0;
      }
    }

    .beratungshero--avatar-img--sm {
      height: 60px;
      width: 60px;
    }

    .beratungshero--avatar-img--xs {
      height: 40px;
      width: 40px;
    }

    .beratungshero--avatar-img--multiple1-left {
      position: absolute;
      margin-left: -40px;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      left: 0;
    }

    .beratungshero--avatar-img--multiple1-right {
      position: absolute;
      margin-right: -40px;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      right: 0;
    }

    .beratungshero--avatar--multiple2 .beratungshero--avatar-img {
      margin-left: -18px;
    }

    .beratungshero--avatar-img--multiple2-right {
      position: absolute;
      margin-right: -16px;
      margin-top: 2px;
      right: 0;
    }

    .beratungshero--avatar-img--multiple2-top-right {
      position: absolute;
      margin-right: -3px;
      margin-top: -55px;
      top: 0;
      right: 0;
    }

    .beratungshero--avatar-title {
      background-color: ${widgetBg || primary};
      border-radius: 4px;
      color: ${widget || "#fff"};
      font-size: 12px;
      line-height: 1;
      padding: 2px 4px;
    }

    .beratungshero--avatar-additional-title {
      background-color: ${widgetBg || primary};
      border-radius: 4px;
      color: ${widget || "#fff"};
      font-size: 12px;
      line-height: 1;
      padding: 2px 4px;
      width: 65px;
      margin: 0 auto;
    }

    .beratungshero--popup {
      background: ${popupBg};
      border: ${popupBorder};
      border-radius: 4px;
      padding: 20px;
      position: fixed;
      bottom: 10px;
      left: 10px;
      right: 10px;
      transition: all .5s ease-in-out;
      transform: scale(0);
      transform-origin: right bottom;
      z-index: 101;
    }

    .beratungshero--popup--mobile {
      padding: 0px;
      border: none;
      bottom: 5px;
      left: 5px;
      right: 5px;
    }

    .beratungshero--popup.beratungshero--popup--left {
      transform-origin: left bottom;
      left: 10px;
    }

    .beratungshero--popup--mobile.beratungshero--popup--left {
      left: 5px;
    }

    .beratungshero--title {
      margin: 0 15px 24px 15px;
      text-align: center;
      font-weight: 700;
    }

    .beratungshero--title--mobile {
      margin-bottom: 9px;
      text-align: left;
      font-weight: 700;
    }

    .beratungshero--body {
      position: relative;
    }

    .beratungshero--links-container {
      display: flex;
      justify-content: space-between;
    }

    .beratungshero--links-container--mobile {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      background-color: ${popupBgDark};
      border: 1px solid ${popupBgDark};
      border-radius: 0 0 4px 4px;
      font-size: 12px;
    }

    .beratungshero--link a {
      display: flex;
      align-items: center;
      border-bottom: 0 !important;
      color: ${popup || "#fff"} !important;
      text-decoration: underline !important;
    }

    .beratungshero--link--mobile span {
      display: flex;
      align-items: center;
      color: #fff !important;
    }

    .beratungshero--link--mobile a {
      display: flex;
      align-items: center;
      border-bottom: 0 !important;
      color: #fff !important;
      text-decoration: underline !important;
    }

    .beratungshero--avatar-container {
      position: relative;
      line-height: 0;
    }

    .beratungshero--avatar-live {
      background-color: ${liveBg || "#e84a42"};
      border-radius: 2px;
      color: #fff;
      font-size: 8px;
      padding: 4px;
      position: absolute;
      bottom: 10px;
      left: calc(50% + 20px);
      line-height: 1;
    }

    .beratungshero--avatar .beratungshero--avatar-live {
      bottom: 0;
      right: 0;
      left: auto;
    }

    .beratungshero--body img {
      border-radius: 50%;
      display: block;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      width: 100px;
    }

    .beratungshero-list {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }

    .beratungshero--list-item {
      align-items: center;
      display: flex;
      margin-bottom: 4px;
    }

    .beratungshero--list-item.beratungshero--list-item--pdp {
      font-size: 13px;
    }

    .beratungshero--icon {
      flex-shrink: 0;
      fill: currentColor;
      margin-right: 10px;
      width: 20px;
    }

    .beratungshero--icon-calendar {
      fill: currentColor;
      margin-right: 5px;
    }

    .beratungshero--icon-info {
      flex-shrink: 0;
      fill: currentColor;
      margin-right: 5px;
      width: 20px;
    }

    .beratungshero-niveki-button-wrapper {
      display: flex;
      justify-content: center;
    }

    .beratungshero-niveki-button {
      background-color: ${nivekiButtonBg};
      border-radius: 4px;
      border: 0 !important;
      color: ${popupButton} !important;
      margin-bottom:16px;
      overflow: hidden;
      width: 100%;
      padding: 10px;
      text-align: left;
      text-decoration: none;
    }

    .beratungshero-new-niveki-button {
      border-radius: 4px;
      border: 2px solid ${popupButton} !important;
      color: ${popupButton} !important;
      margin-bottom:16px;
      overflow: hidden;
      width: 100%;
      padding: 10px;
      text-align: left;
      text-decoration: none;
      display: flex;
      font-weight: bold;
      justify-content: center;
      margin: 20px auto;
    }

    .beratungshero-content--mobile {
      padding: 20px;
      border: ${popupBorder};
      border-radius: 4px;
    }

    .beratungshero-niveki-button > span {
      font-weight: bold;
    }

    .beratungshero-niveki-button > div {
      font-size: 12px;
    }

    .beratungshero--more {
      align-items: center;
      background: ${popupButtonBg};
      border-radius: 4px;
      border: 0 !important;
      color: ${popupButton} !important;
      display: flex;
      font-weight: bold;
      justify-content: center;
      margin: 20px auto;
      overflow: hidden;
      padding: 10px;
      text-align: center;
      text-decoration: none !important;
    }

    .beratungshero--more--mobile {
      align-items: center;
      background-color: ${popupButtonBg};
      border-radius: 4px;
      border: 0 !important;
      color: ${popupButton} !important;
      display: flex;
      font-weight: bold;
      justify-content: center;
      margin: 0 auto;
      overflow: hidden;
      padding: 10px;
      text-align: center;
      text-decoration: none;
    }

    .beratungshero--chat {
      align-items: center;
      border: 0 !important;
      color: #fff !important;
      display: flex;
      font-weight: bold;
      justify-content: center;
      margin-top: 10px;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;
      padding: 10px;
      text-align: center;
      text-decoration: none;
    }

    .beratungshero--hidden {
      display: none !important;
    }

    .beratungshero--header {
      background-size: cover;
      background-position: top;
      height: 200px;
      margin-bottom: 20px;
      position: relative;
      border-radius: 4px;
    }

    .beratungshero--header-live {
      position: absolute;
      top: 10px;
      left: 10px;
      background-color: ${liveBgPopup || "#e84a42"};
      color: #fff;
      padding: 6px;
      border-radius: 4px;
      line-height: 1;
    }

    .beratungshero--show-video {
      margin-right: 10px;
    }

    .beratungshero--popup--video {
      width: 180px;
      left: auto;
      padding: 11px 11px 9px 11px;
      font-size: 12px;
    }

    .beratungshero-popup__video {
      position: relative;
      margin-bottom: 9px;
    }

    .beratungshero-popup__video__live {
      font-size: 11px;
      top: 6px;
      left: 6px;
    }

    .beratungshero-popup__video__close {
      width: 36px;
      height: 36px;
      border-width: 6px;
    }

    .beratungshero-popup__video > video {
      width: 100%;
      height: auto;
    }

    .beratungshero-popup__video__button-no-sound {
      position: absolute;
      width: 76px;
      height: 76px;
      border-radius: 38px;
      background: rgba(255, 255, 255, 0.33);
      border: 1px solid rgba(0, 0, 0, 0.15);
      top: 50%;
      margin-top: -34px;
      left: 50%;
      margin-left: -34px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .beratungshero-popup__video__button-wrapper {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 8px 8px 12px 8px;
    }

    .beratungshero-popup__video__button {
      width: 100% !important;
      padding: 6px;
      margin: 0;
      font-size: 12px;
    }

    @media screen and (min-width: 480px) {
      .beratungshero--popup {
        left: auto;
        width: 440px;
      }

      .beratungshero--popup--video {
        width: 214px;
        font-size: inherit;
        padding: 13px 13px 9px 13px;
      }

      .beratungshero-popup__video__button {
        font-size: 14px;
      }

      .beratungshero--more, .beratungshero-new-niveki-button, .beratungshero--chat {
        width: 75%;
      }

      .beratungshero-niveki-button {
        width: 85%;
      }
    }

    ${(theme === "sportxx" || theme === "sportx") && lang === "de" ? "" : `.back-to-top:not(.back-to-top__hidden) {
          bottom: 120px;
        }`}

    @media screen and (min-width: 768px) {
      .beratungshero--avatar {
        bottom: 30px;
        right: 30px;
      }

      .beratungshero--avatar.beratungshero--avatar--left {
        left: 30px;
      }

      .beratungshero--avatar.beratungshero--avatar--multiple1 {
        right: 70px;
      }

      .beratungshero--avatar.beratungshero--avatar--multiple2 {
        right: 46px;
      }

      .beratungshero--popup {
        bottom: 30px;
        right: 30px;
      }

      .beratungshero--popup.beratungshero--popup--left {
        left: 30px;
      }

      ${(theme === "sportxx" || theme === "sportx") && lang === "de" ? "" : `.back-to-top:not(.back-to-top__hidden) {
          bottom: 140px;
        }`}
    }
  `;
    const bannerCss = `
  .beratungshero--root {
    width: 100%;
  }

  .beratungshero--banner {
    margin-top: 48px;
    width: 100%;
  }

  .beratungshero--banner .beratungshero--title {
    margin: 0 auto 0 auto;
    text-align: left;
  }

  .beratungshero--banner .beratungshero--body {
    background-color: #f2f2f2;
    color: #333;
    padding: 20px;
  }

  .beratungshero--banner .beratungshero--body.beratungshero--body--pdp {
    background-color: transparent;
  }

  .beratungshero--left {
    flex: 1;
  }

  .beratungshero--banner img {
    height: 120px;
    margin-left: 20px;
  }

  .beratungshero--banner .beratungshero--chat {
    color: #333 !important;
  }

  .beratungshero--banner .beratungshero--avatar-live {
    bottom: auto;
    top: 0;
    left: 140px;
    font-size: 12px;
  }

  .beratungshero--banner .beratungshero--list-item svg {
    fill: #555;
  }

  .beratungshero--banner .beratungshero-list {
    justify-content: flex-start;
  }

  .beratungshero--banner .beratungshero--buttons {
    display: flex;
    margin-top: 20px;
  }

  .beratungshero--banner .beratungshero--buttons.beratungshero--buttons--pdp {
    margin-top: 5px;
  }

  .beratungshero--banner .beratungshero--buttons.beratungshero--buttons--pdp .beratungshero--more {
    padding: 10px 10px;
  }

  .beratungshero--banner .beratungshero--buttons-center {
    align-items: center;
  }

  .beratungshero--banner .beratungshero--more {
    flex-direction: column;
    line-height: 1;
    margin-top: 0;
    padding: 10px 50px;
  }

  .beratungshero--banner .beratungshero--buttons-center .beratungshero--more {
    width: 100%;
  }

  .beratungshero--banner .beratungshero--buttons .beratungshero--icon {
    margin-bottom: 10px;
    margin-right: 0;
  }

  .wishlist--container .beratungshero--banner {
    margin-bottom: 48px;
  }

  .p-cart--container .beratungshero--banner {
    margin-bottom: 48px;
  }

  @media screen and (min-width: 480px) {
    .beratungshero--banner .beratungshero--more {
      max-width: 360px;
      width: auto;
    }

    .beratungshero--banner .beratungshero--buttons-center .beratungshero--more {
      max-width: 100%;
      width: 100%;
    }

    .beratungshero--banner .beratungshero--chat {
      max-width: 360px;
      width: auto;
    }

    .wishlist .beratungshero--banner .beratungshero--body {
      display: flex;
    }

    .wishlist--container .beratungshero--banner .beratungshero--buttons-center {
      padding-left: 10px;
    }

    .p-cart .beratungshero--banner .beratungshero--body {
      display: flex;
    }

    .p-cart--container .beratungshero--banner .beratungshero--buttons-center {
      padding-left: 10px;
    }
  }

  @media screen and (min-width: 992px) {
    .beratungshero--banner .beratungshero--body:not(.beratungshero--body--pdp) {
      display: flex;
    }

    .beratungshero--banner.beratungshero--banner--pdp {
      display: flex;
    }

    .beratungshero--body.beratungshero--body--pdp {
      padding-top: 0px;
      margin-left: 45px;
    }

    .beratungshero--banner .beratungshero--text {
      padding-right: 20px;
    }

    .beratungshero--banner .beratungshero--buttons {
      display: block;
      margin-top: 0;
    }

    .beratungshero--banner .beratungshero--buttons.beratungshero--buttons-center {
      display: flex;
    }

    .beratungshero--banner .beratungshero--more-chat {
      margin-top: 20px;
    }
  }

  @media screen and (min-width: 1200px) {
  }

  @media screen and (min-width: 1560px) {
  }

  .beratungshero-banner-wrapper {
    position: relative;
    padding-top: 27px;
    margin-top: -28px;
    margin-right: -20px;
    margin-left: -20px;
  }

  .beratungshero-banner {
    margin: 27px;
    box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    border-radius: 16px;
    position: relative;
    background-color: white;
  }

  .beratungshero-banner-background {
    width: 100%;
    background: ${primary};
    position: absolute;
    height: 65%;
    border-radius: 16px;
  }

  .beratungshero-banner__img {
    width: 100%;
    height: 188px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 16px 16px 0px 0px;
  }

  .beratungshero-banner__content {
    padding: 10px 24px 24px 24px;
  }

  .beratungshero-banner__title {
    font-size: 20px;
    font-weight: 600;
  }

  .beratungshero-banner__list {
    margin: 16px 0px 27px 5px;
  }

  .beratungshero-banner__list__item {
    align-items: center;
    display: flex;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .beratungshero-banner__list__item > svg {
    color: ${primary}
  }

  .beratungshero-banner__button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 13px;
    background: ${primary};
    border-radius: 8px;
    width: 100%;
    color: white !important;
  }

  .beratungshero-banner__button__live {
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.4);
    padding: 4px 10px 4px 6px;
    font-size: 12px;
    border-radius: 4px;
    letter-spacing: 0.05em;
    margin-right: 10px;
  }

  .beratungshero-banner__button__live__green-bubble {
    width: 8px;
    height: 8px;
    background-color: #1FAF7C;
    border-radius: 4px;
    margin-right: 4px;
  }

  @media screen and (min-width: 992px) {
    .beratungshero-banner-wrapper {
      margin: 0;
    }

    .beratungshero-banner {
      display: flex;
      margin: 27px 0px 27px 27px;
    }

    .beratungshero-banner__img {
      width: 50%;
      height: auto;
      border-radius: 16px 0px 0px 16px;
    }

    .beratungshero-banner-background {
      width: 55%;
      height: 100%;
    }
  }

  `;
    const stickerCss = `
    .beratungshero--sticker {
      background-color: ${stickerBg || primary};
      color: white !important;
      position: absolute;
      right: 0;
      padding: 8px 16px;
      cursor: pointer;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      font-size: 90%;
      line-height: 1;
      z-index: 1;
      border-bottom: 0px !important;
    }

    @media screen and (max-width: 990px) {
      .beratungshero--sticker {
        top: 45px;
      }
    }

    .beratungshero--sticker:hover {
      background-color: ${stickerBgHover || primaryDark};
    }

    .beratungshero--sticker svg {
      fill: currentColor;
      height: 10px;
      margin-left: 8px;
      width: 10px;
    }

    .beratungshero--sticker-live {
      position: absolute;
      top: 0;
      right: 0;
      background-color: ${liveBg || "#e84a42"};
      padding: 4px;
      border-radius: 4px;
      margin-top: -16px;
      margin-right: 8px;
    }

    .beratungshero--sticker--new {
      background-color: ${stickerBg || primary};
      color: white !important;
      position: absolute;
      right: 0;
      padding: 4px 6px;
      cursor: pointer;
      border-radius: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: -5px;
      line-height: 1;
      z-index: 1;
      border-bottom: 0px !important;
    }

    .beratungshero--sticker--new > span {
      margin-left: 44px;
      max-width: 165px;
      line-height: 20px;
    }

    .beratungshero--sticker--new__consultant-image {
      border: 2px solid white;
      border-radius: 22px;
      height: 44px;
      width: 44px;
      flex-shrink: 0;
    }

    .beratungshero--sticker--new__consultant-image--right {
      position: absolute;
      left: 36px;
      z-index: -1;
    }

    .beratungshero--sticker--new__circle {
      background-color: ${primaryDark};
      color: white;
      border-radius: 22px;
      height: 44px;
      width: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 12px;
      flex-shrink: 0;
    }


    @media screen and (max-width: 990px) {
      .beratungshero--sticker--new {
        top: 29px;
      }
    }

    @media screen and (max-width: 425px) {
      .beratungshero--sticker--new {
        width: 100%;
      }
      .beratungshero--sticker--new > span {
        max-width: none;
      }
    }


    .beratungshero--mobile-configurator {
      border: 2px solid transparent;
      border-width: 2px !important;
      border-color: ${primary};
      color: ${primary};
      cursor: pointer;
      border-radius: 4px;
      text-decoration: none;
      line-height: 1;
      font-size: 1.4rem;
      padding: 6px 8px;
      width: 100%;
      font-weight: 700;
      font-style: normal;
      display: inline-flex;
      flex-flow: column nowrap;
      align-items: center;
    }

    .beratungshero--miocolor-product-finder {
      border: 2px solid transparent;
      border-width: 2px !important;
      border-color: ${primary};
      color: ${primary};
      cursor: pointer;
      border-radius: 4px;
      text-decoration: none;
      font-size: 1.4rem;
      font-weight: 700;
      font-style: normal;
      display: inline-flex;
      flex-flow: column nowrap;
      align-items: center;
      float: right;
      padding: 0 1em;
      height: 32px;
      line-height: 28px;
      margin-bottom: 10px;
    }

    @media screen and (max-width: 991px) {
      .beratungshero--miocolor-product-finder {
        margin-right: 8px;
      }
    }

    .beratungshero--miocolor-product-finder > span  {
      padding: 0 4px;
      font-family: "Helvetica Neue Condensed Bold",Helvetica,Arial,sans-serif;
      font-weight: 400;
    }

    .cursor-pointer {
      cursor: pointer;
    }

    .beratungshero-video-wrapper{
        overflow: hidden
    }

    .beratungshero-video-wrapper video{
        margin-left: -3px
    }

    .lazy {
      background-image: none !important;
    }

    .beratungshero-button {
      padding: 8px 8px;
      cursor: pointer;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 90%;
      line-height: 1;
      z-index: 1;
    }

    .beratungshero-button > span {
      text-align: center;
      font-weight: bold;
    }

    .beratungshero__livestream-fake__widget > video {
      height: 100%;
      width: 100%;
      border-radius: 9px;
      position: absolute;
    }

    .beratungshero__livestream-fake__live {
      z-index: 1;
      position: absolute;
      top: 7px;
      left: 7px;
      padding: 7px 8px;
      font-size: var(--live-label-font-size, 12px);
      color: var(--live-label-text-color, #ffffff);
      background-color: var(--live-label-bg-color, #E12147);
      border-radius: var(--border-radius, 0);
      font-weight: var(--live-label-font-weight, 'normal');
    }

    .beratungshero__livestream-fake__fader {
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #000;
      opacity: 0;
      top: 0;
      left: 0;
      transition: opacity .2s;
      border-radius: 8px;
      cursor: pointer;
    }

    .beratungshero__livestream-fake--active > .beratungshero__livestream-fake__fader {
        opacity: .65;
    }

    .beratungshero__livestream-fake__cta {
      opacity: 0;
      z-index: 1;
      transition: opacity .2s;
      border: 1px solid #fff;
      text-align: center;
      padding: 8px;
      margin-left: 16px;
      margin-right: 16px;
      font-size: 12px;
      color: white;
    }

    .beratungshero__livestream-fake__cta-container {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .beratungshero__livestream-fake__close {
      position: absolute;
      top: 0;
      right: 0;
      width: 44px;
      height: 44px;
      z-index: 1;
      transition: opacity .2s;
    }

    .beratungshero__livestream-fake--active .beratungshero__livestream-fake__cta {
        opacity: 1;
    }

    .beratungshero__livestream-fake__live-circle {
      position: fixed;
      bottom: 16px;
      right: 16px;
      width: 56px;
      height: 56px;
      text-transform: var(--live-label-text-transform, 'uppercase');
      color: var(--live-label-text-color, #ffffff);
      background-color: var(--live-label-bg-color, #E12147);
      font-weight: var(--live-label-font-weight, 'normal');
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      font-size: 12px;
      font-family: Haas Grot, Helvetica, Arial, Verdana, Tahoma, sans-serif;
    }

    .beratungshero__livestream-fake__overlay {
      position: fixed;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.55);
      overscroll-behavior: none;
      z-index: 2147483647;
      cursor: pointer;
    }

    .beratungshero__livestream-fake__overlay__content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      max-width: 500px;
    }

    .beratungshero__livestream-fake__overlay__live {
      border-radius: 4px;
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 500;
      background-color: #2a2a2a;
      font-family: "NeueHaasGrotText",sans-serif;
      padding: 8px;
      background-color: #e12147;
      color: #fff;
      position: absolute;
      top: 7px;
      left: 7px;
    }

    .beratungshero__livestream-fake__overlay__close {
      position: absolute;
      top: 0;
      right: 0;
      width: 48px;
      height: 48px;
      z-index: 1;
      transition: opacity .2s;
      cursor: pointer;
    }

    .beratungshero__livestream-fake__overlay__spinner {
      border: 5px solid #f3f3f3;
      -webkit-animation: spin 1s linear infinite;
      animation: spin 1s linear infinite;
      border-top: 5px solid #555;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      margin-right: auto;
      margin-left: auto;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
    const switchCss = ".switch{display:inline-block;vertical-align:middle;cursor:pointer;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;box-sizing:content-box;outline:none}.switch,.switch small{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.switch small{font-size:12px;top:0;border-radius:100%;text-align:center;display:block;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.4);-webkit-transition:all .2s;transition:all .2s;overflow:hidden;color:#000}.switch-default{width:50px;height:30px;border-radius:20px;line-height:30px}.switch-default small{width:30px;height:30px}.switch-small{border-radius:20px;height:20px;width:33px;line-height:20px}.switch-small small{height:20px;width:20px}.switch-large{border-radius:40px;height:40px;width:66px;line-height:40px}.switch-large small{height:40px;width:40px}.switch-disabled{opacity:.5}";
    const css = popupCss + bannerCss + stickerCss + switchCss;
    const style = document.createElement("style");
    style.type = "text/css";
    style.id = "bh-widget-style";
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}
function $e5d437f86f4d95b1$export$eb1d1800c11907c2() {
    console.log("removeStyles");
    const style = document.getElementById("bh-widget-style");
    console.log(style);
    if (style) style.remove();
}




const $1affb8d846f7c972$export$f7c6a91a611d8278 = {
    bikeworld: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1632476949/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0001_tqk0ke.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1632476697/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0002-min_wnvnjb.jpg"
    ],
    doitgarden: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1619439397/consultants/fm_live_videoberatung_doit_wankdorf_nicole_grau_4_21_P3A2309_tjymld.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1619439451/consultants/fm_live_videoberatung_doit_wankdorf_nicole_grau_4_21_P3A2418_ipgvdr.jpg"
    ],
    melectronics: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571632/consultants/eahunbbkeofnactmc3nl.jpg",
        "/static/images/fachmarkt/popup_melectronics_termin.jpg"
    ],
    micasa: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613570541/consultants/bo8f5ixderizksjdeohd.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613570547/consultants/k0quu9fia4vbnaiy4spk.jpg"
    ],
    sportxx: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571096/consultants/ch6bazosn8fkpgscfm7g.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1613571102/consultants/idf3elwcez8syrzw7hns.jpg"
    ],
    sportx: [
        "https://res.cloudinary.com/db4fij86r/image/upload/w_500/v1693299009/consultants/beratungsheros_sportxx_8_23_Micha_Burkolter_P3A8623-1_1_cpjjec.png",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1693311499/image_4_cftkdf.png"
    ],
    klubschule: [
        "https://res.cloudinary.com/db4fij86r/image/upload/v1609830211/consultants/cn2nct1sesbzi9krv5gj.jpg",
        "https://res.cloudinary.com/db4fij86r/image/upload/v1609830226/consultants/agil4a2ks1uyxi1ntyqo.jpg"
    ]
};
const $1affb8d846f7c972$export$af5fbebaeacc3fa3 = {
    de: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_fonczd.png",
    fr: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_FR_bhqoi0.png",
    it: "https://res.cloudinary.com/db4fij86r/image/upload/v1675503420/mbudget/mbudget_IT_sdlwpm.png"
};



function $11990f87f0d79dff$export$d856f5947026c431({ consultant: consultant, theme: theme, lang: lang, variant: variant, hidden: hidden = false, booking: booking, bookingLink: bookingLink, landingPageUrl: landingPageUrl, tenant: tenant, position: position, widgetType: widgetType = "default", popupVideoUrl: popupVideoUrl = null, from: from, url: url }) {
    var _window_BH, _window;
    if ((_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.widgetIsDisabled) return;
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const smartphonePage = (0, $1a19ad51aa7d708b$export$3c89af888305343f)(url);
    let avatarImage = booking ? (0, $1affb8d846f7c972$export$f7c6a91a611d8278)[theme][0] : consultant ? consultant.imageAvatar : null;
    let branchImage = smartphonePage ? (0, $1affb8d846f7c972$export$af5fbebaeacc3fa3)[lang] : booking ? (0, $1affb8d846f7c972$export$f7c6a91a611d8278)[theme][1] : consultant ? consultant.imageBranch : null;
    if (avatarImage.indexOf("https://") === 0) avatarImage = avatarImage.replace("upload/", "upload/w_160/");
    else avatarImage = window.BH_URL + avatarImage;
    if (branchImage.indexOf("https://") === 0) branchImage = branchImage.replace("upload/", "upload/w_800/");
    else branchImage = window.BH_URL + branchImage;
    // For bikeworld to sportxx fallback during winter
    if (from === "bikeworld") {
        avatarImage = "https://res.cloudinary.com/db4fij86r/image/upload/v1632476949/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0001_tqk0ke.jpg";
        branchImage = "https://res.cloudinary.com/db4fij86r/image/upload/v1632476697/consultants/unter_fm_bike_world_2021_onlineberater_daniel_berger_B2021_0002-min_wnvnjb.jpg";
        landingPageUrl = "https://www.bikeworld.ch/de/cp/videoberatung";
    }
    /*function redirectToCall() {
    let shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) {
      shopUrl = "https://qual-www.micasa.ch/de/p/405750100000/diener";
    }
    let videoCallUrl = booking
      ? bookingLink
      : `${
          window.BH_URL
        }/${theme}/${lang}?connect=auto&url=${encodeURIComponent(
          shopUrl
        )}&consultantId=${consultant._id}`;

    window.open(videoCallUrl, "_blank", "noopener noreferrer");
  }*/ const popupPrimaryButtonUrl = getPopupPrimaryButtonUrl(booking, bookingLink, theme, lang, $11990f87f0d79dff$var$getShopUrl(), consultant);
    const div = document.createElement("div");
    div.className = "beratungshero--root";
    if (hidden) div.style.display = "none";
    const nivekiEnabled = tenant.nivekiEnabled && !!window.BH.nivekiEnabled;
    if (popupVideoUrl !== null && !booking) div.innerHTML = `
    <div class="beratungshero--popup beratungshero--popup--video ${position === "left" ? "beratungshero--popup--left" : ""}">
      <div id="beratungshero-popup-content">
      <div class="beratungshero-popup__video">
        <video class="js-beratungshero-popup-video"
          src="${window.BH_URL + popupVideoUrl}"
          autoplay="true" playsinline="true" webkit-playsinline="true" muted loop>
        </video>
        <div class="beratungshero--close beratungshero-popup__video__close">${0, $773b60ff9ada0e5d$export$8360e631d277ea4d}</div>
        <div class="beratungshero--header-live beratungshero-popup__video__live">LIVE</div>
        <div class="beratungshero-popup__video__button-no-sound js-beratungshero-popup-no-sound">${0, $773b60ff9ada0e5d$export$c3694a0927aa4b45}</div>
        <div class="beratungshero-popup__video__button-wrapper">
          <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more beratungshero-popup__video__button cursor-pointer" href="${getPopupPrimaryButtonUrl()}" target="_blank" rel="noreferrer noopener">
            Video-Beratung starten
          </a>
        </div>
        </div>

        <!--<div class="beratungshero--header lazy" style="background-image: url('${branchImage}');">
          <div class="beratungshero--close">${0, $773b60ff9ada0e5d$export$8360e631d277ea4d}</div>
          <div class="beratungshero--header-live">LIVE</div>
        </div>-->

        <div class="beratungshero--links-container" ${theme === "klubschule" ? `style="display: none;"` : ""}>
          <div class="beratungshero--link">
          </div>
          <div id="beratungshero-link-how-it-works" class="beratungshero--link">
            <a href=${landingPageUrl} target="_blank" rel="noopener">${0, $773b60ff9ada0e5d$export$a80b3bd66acc52ff}${texts.widgetInfoLink}</a>
          </div>
        </div>
      </div>
    </div>`;
    else if (variant === 1 || booking) // Large PopUp
    div.innerHTML = `
    <div class="beratungshero--popup ${booking ? "beratungshero--booking" : ""} ${position === "left" ? "beratungshero--popup--left" : ""}">
      <div id="beratungshero-popup-content">
        <div class="beratungshero--header lazy" style="background-image: url('${branchImage}');">
          <div class="beratungshero--close">${0, $773b60ff9ada0e5d$export$8360e631d277ea4d}</div>
          ${booking ? "" : `<div class="beratungshero--header-live">LIVE</div>`}
        </div>
        <div class="beratungshero--title" ${nivekiEnabled ? 'style="margin-bottom: 0px"' : ""}>
          ${smartphonePage ? texts.mBudget.widget.title : booking ? texts.widgetTitleBooking : nivekiEnabled ? texts.nivekiTitle : texts.widgetTitle[theme] || texts.widgetTitle.default}
        </div>
        ${!nivekiEnabled && theme !== "miocolor" ? getNotSeenPart() : ""}
        ${theme === "miocolor" ? getMiocolorPart() : ""}
        <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more cursor-pointer" href="${getPopupPrimaryButtonUrl()}" target="_blank" rel="noreferrer noopener" style="${nivekiEnabled ? "margin-top: 10px; margin-bottom: 10px" : ""}">
          ${booking ? (0, $773b60ff9ada0e5d$export$56bbcdb8aca31149) : ""}
          ${booking ? texts.widgetButtonBooking : nivekiEnabled ? texts.nivekiPrimaryButton : smartphonePage ? texts.mBudget.widget.cta : texts.widgetButton[theme] || texts.widgetButton.default}
        </a>
        ${nivekiEnabled ? getNotSeenPart() : ""}
        ${nivekiEnabled ? getNivekiButton() : ""}
        <div class="beratungshero--links-container" ${theme === "klubschule" ? `style="display: none;"` : ""}>
          <div class="beratungshero--link">
          </div>
          <div id="beratungshero-link-how-it-works" class="beratungshero--link">
            <a href=${landingPageUrl} target="_blank" rel="noopener">${0, $773b60ff9ada0e5d$export$a80b3bd66acc52ff}${nivekiEnabled ? texts.nivekiWidgetInfoLink : texts.widgetInfoLink}</a>
          </div>
        </div>
      </div>
    </div>
  `;
    else div.innerHTML = `
    <div class="beratungshero--popup beratungshero--popup--mobile ${booking ? "beratungshero--booking" : ""} ${position === "left" ? "beratungshero--popup--left" : ""}">
      <div id="beratungshero-popup-content">
        <div class="beratungshero--close--mobile">${0, $773b60ff9ada0e5d$export$8360e631d277ea4d}</div>
        <div style="display: flex; position:relative">
          <div style="width: 66.66%">
            <div style="padding: 12px 14px 12px 16px">
              <div class="beratungshero--title--mobile">
                ${smartphonePage ? texts.mBudget.widget.title : texts.widgetTitle[theme] || texts.widgetTitle.default}
              </div>
              <a id="beratungshero-popup-video" class="js-beratungshero-popup-primary-button beratungshero--more--mobile cursor-pointer" href="${getPopupPrimaryButtonUrl()}" target="_blank" rel="noreferrer noopener">
                ${smartphonePage ? texts.mBudget.widget.cta : texts.widgetButton[theme] || texts.widgetButton.default}
              </a>
            </div>
          </div>
          <div style="width: 33.33%; background-image: url(${branchImage}); -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%); border-radius: 0 4px 0 0; background-size: cover;
        background-position: center;"></div>
        </div>
        <div class="beratungshero--links-container--mobile" ${theme === "klubschule" ? `style="display: none;"` : ""}>
          <div class="beratungshero--link--mobile">
              <span>${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${smartphonePage ? texts.mBudget.widget.subtitle : texts.widgetBodyBullet1}</span>
          </div>
          <div id="beratungshero-link-how-it-works" class="beratungshero--link--mobile">
            <a href=${landingPageUrl} target="_blank" rel="noopener">${0, $773b60ff9ada0e5d$export$a80b3bd66acc52ff}${texts.widgetInfoLink}</a>
          </div>
        </div>
      </div>
    </div>
  `;
    div.innerHTML += getWidget();
    document.body.appendChild(div);
    const avatar = document.querySelector(".beratungshero--avatar");
    avatar.onclick = togglePopup;
    let closeButton = document.querySelector(".beratungshero--close");
    if (!closeButton) closeButton = document.querySelector(".beratungshero--close--mobile");
    closeButton.onclick = function() {
        togglePopup();
        if (popupVideoUrl !== null) {
            const video = document.querySelector(".js-beratungshero-popup-video");
            video.muted = true;
            const activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
            setTimeout(()=>{
                activateSoundButton.style.display = "flex";
            }, 1000);
        }
    };
    const videoCallButton = document.querySelector("#beratungshero-popup-video");
    videoCallButton.onclick = function(e) {
        if (booking) (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_APPOINTMENT_CLICKED");
        else {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_CLICKED", {
                url: document.location.href
            });
            (0, $bd64aa99694b6ef2$export$5009e7f3fa7b4cd3)("beratungshero_button_clicked");
        }
    /*if (!booking && tenant.nivekiEnabled && !isMobile()) {
      e.preventDefault(); // Don't redirect to call
      logEvent("POPUP_NIVEKI");
      showNiveki();
    }*/ };
    const howItWorksLink = document.querySelector("#beratungshero-link-how-it-works");
    howItWorksLink.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("LINK_HOW_IT_WORKS_CLICKED");
    };
    const nivekiButton = document.querySelector("#beratungshero-niveki-button");
    if (nivekiButton) nivekiButton.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_POPUP_NIVEKI_CLICKED");
    };
    const activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
    if (activateSoundButton) activateSoundButton.onclick = activateSoundButtonClicked;
    function togglePopup() {
        const popup = document.querySelector(".beratungshero--popup");
        if (window.BH.widgetClosed) {
            if (popupVideoUrl !== null) $11990f87f0d79dff$export$ae6c4758b5042ef8();
            $11990f87f0d79dff$export$cfae72848eff8ed2();
            popup.style.transform = "scale(1)";
            avatar.querySelector(".beratungshero--avatar-img").classList.remove("beratungshero--avatar-pulse");
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("WIDGET_OPENED");
        } else {
            popup.style.transform = "scale(0)";
            avatar.querySelector(".beratungshero--avatar-img").classList.add("beratungshero--avatar-pulse");
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("WIDGET_CLOSED");
        }
        window.BH.widgetClosed = !window.BH.widgetClosed;
    }
    function showNiveki() {
        const popupContent = document.querySelector("#beratungshero-popup-content");
        popupContent.innerHTML = getNivekiContent();
        const nivekiButton1 = document.querySelector("#beratungshero-niveki-button-1");
        nivekiButton1.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_1_CLICKED");
            $11990f87f0d79dff$var$openInNewTab(texts.nivekiButton1Link[theme]);
        };
        const nivekiButton2 = document.querySelector("#beratungshero-niveki-button-2");
        nivekiButton2.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_2_CLICKED");
            $11990f87f0d79dff$var$openInNewTab(texts.nivekiButton2Link[theme]);
        };
        const nivekiButton3 = document.querySelector("#beratungshero-niveki-button-3");
        nivekiButton3.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_3_CLICKED");
            $11990f87f0d79dff$var$openInNewTab(texts.nivekiButton3Link[theme]);
        };
        const nivekiButtonVideo = document.querySelector("#beratungshero-niveki-button-video");
        nivekiButtonVideo.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_POPUP_TRIAGE_CALL_CLICKED");
        };
        let closeButton = document.querySelector(".beratungshero--close");
        if (!closeButton) closeButton = document.querySelector(".beratungshero--close--mobile");
        closeButton.onclick = togglePopup;
    }
    function getWidget() {
        let multipleConsultantAvatars;
        if (theme === "melectronics") multipleConsultantAvatars = [
            "https://res.cloudinary.com/db4fij86r/image/upload/v1629181421/consultants/fotos_onlineberater_melectronics_sch%C3%B6nb%C3%BChl_002-min_kn9l3z.jpg",
            "https://res.cloudinary.com/db4fij86r/image/upload/v1629181466/consultants/fotos_onlineberater_melectronics_sch%C3%B6nb%C3%BChl_001-min_ajtuay.jpg"
        ];
        else if (theme === "micasa") multipleConsultantAvatars = [
            "https://res.cloudinary.com/db4fij86r/image/upload/v1612423871/consultants/a8utsbdbio1ki7sikfqg.jpg",
            "https://res.cloudinary.com/db4fij86r/image/upload/v1613570250/consultants/zwnk5rtfbqyjnxqyb7tg.jpg"
        ];
        return `<button class="beratungshero--button-reset beratungshero--avatar beratungshero--avatar--${widgetType} ${position === "left" ? "beratungshero--avatar--left" : ""}">
      <div class="beratungshero--avatar-container">
        ${widgetType === "multiple1" ? `<div class="beratungshero--avatar-img beratungshero--avatar-img--sm beratungshero--avatar-img--multiple1-left beratungshero--avatar-pulse">
          <img src="${multipleConsultantAvatars[0]}"  alt="consultant"/>
        </div>
        <div class="beratungshero--avatar-img beratungshero--avatar-img--sm beratungshero--avatar-img--multiple1-right beratungshero--avatar-pulse">
          <img src="${multipleConsultantAvatars[1]}"  alt="consultant"/>
        </div>` : ""}
        ${widgetType === "multiple2" ? `<div class="beratungshero--avatar-img--sm beratungshero--avatar-img--multiple2-top-right">
          <img src="${multipleConsultantAvatars[0]}"  alt="consultant"/>
        </div>
        <div class="beratungshero--avatar-img--xs beratungshero--avatar-img--multiple2-right">
          <img src="${multipleConsultantAvatars[1]}"  alt="consultant"/>
        </div>` : ""}
        <div class="beratungshero--avatar-img beratungshero--avatar-pulse">
          <img src="${avatarImage}"  alt="consultant"/>
        </div>
        ${booking ? "" : `<div class="beratungshero--avatar-live">${texts.widgetLive}</div>`}
      </div>
      <div class="beratungshero--avatar-title">${booking ? texts.widgetAvatarTitleBooking : texts.widgetAvatarTitle[theme] || texts.widgetAvatarTitle.default}</div>
      ${!booking && $11990f87f0d79dff$var$isSunday() ? `<div class="beratungshero--avatar-additional-title">${texts.widgetSundayToo}</div>` : ""}
      ${!booking && !$11990f87f0d79dff$var$isSunday() && $11990f87f0d79dff$var$getFromOperatingHour(tenant) && $11990f87f0d79dff$var$getToOperatingHour(tenant) ? `<div class="beratungshero--avatar-additional-title">${texts.widgetHours.replace("__FROM__", $11990f87f0d79dff$var$getFromOperatingHour(tenant)).replace("__TO__", $11990f87f0d79dff$var$getToOperatingHour(tenant))}</div>` : ""}
    </button>`;
    }
    function getNivekiContent() {
        return `
    <div ${variant === 2 ? 'class="beratungshero-content--mobile"' : ""}>
      <div style="position: relative; height: 40px;">
        <div class="beratungshero--close">${0, $773b60ff9ada0e5d$export$8360e631d277ea4d}</div>
      </div>
      <div class="beratungshero--title">
        ${texts.nivekiTitle}
      </div>
      <div class="beratungshero-niveki-button-wrapper">
        <button id="beratungshero-niveki-button-1" class="beratungshero-niveki-button cursor-pointer">
          <span>${texts.nivekiButton1}</span>
          <div>${texts.nivekiButton1Subtext}</div>
        </button>
      </div>
      <div class="beratungshero-niveki-button-wrapper">
        <button id="beratungshero-niveki-button-2" class="beratungshero-niveki-button cursor-pointer">
          <span>${texts.nivekiButton2}</span>
          <div>${texts.nivekiButton2Subtext}</div>
        </button>
      </div>
      <div class="beratungshero-niveki-button-wrapper">
        <button id="beratungshero-niveki-button-3" class="beratungshero-niveki-button cursor-pointer">
          <span>${texts.nivekiButton3}</span>
          <div>${texts.nivekiButton3Subtext}</div>
        </button>
      </div>
      <a id="beratungshero-niveki-button-video" class="js-beratungshero-popup-primary-button beratungshero--more cursor-pointer" href="${getPopupPrimaryButtonUrl()}" target="_blank" rel="noreferrer noopener">
        ${texts.nivekiPrimaryButton}
      </a>
    </div>`;
    }
    function getPopupPrimaryButtonUrl() {
        const urlParams = new URLSearchParams();
        if (booking) return `${bookingLink}?${urlParams.toString()}`;
        else {
            urlParams.append("connect", "auto");
            urlParams.append("url", encodeURIComponent($11990f87f0d79dff$var$getShopUrl()));
            urlParams.append("consultantId", consultant._id);
            if (from) urlParams.append("from", from);
            return `${window.BH_URL}/${theme}/${lang}?${urlParams.toString()}`;
        }
    }
    function getNotSeenPart() {
        return `<div class="beratungshero--body">
    <div class="beratungshero-list" ${nivekiEnabled ? 'style="margin-top: 0px"' : ""}>
      <div class="beratungshero--list-item">
        ${smartphonePage ? texts.mBudget.widget.subtitle : booking ? texts.widgetBodyBooking[theme] || texts.widgetBodyBooking.default : `${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${smartphonePage ? texts.mBudget.widget.subtitle : texts.widgetBodyBullet1}`}
      </div>
    </div>
  </div>`;
    }
    function activateSoundButtonClicked() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_ACTIVATE_SOUND_CLICKED");
        const video = document.querySelector(".js-beratungshero-popup-video");
        video.muted = false;
        const activateSoundButton = document.querySelector(".js-beratungshero-popup-no-sound");
        activateSoundButton.style.display = "none";
    }
    function getMiocolorPart() {
        return `
      <div style="text-align: center">
        Unser spezialisierter Farbexperte ber\xe4t Sie live per Video-Beratung \xfcber unser Farbangebot.
      </div>`;
    }
    function getNivekiButton() {
        return `<a id="beratungshero-niveki-button" class="beratungshero-new-niveki-button cursor-pointer" href="${texts.nivekiButtonLink[theme]}" target="_blank" rel="noreferrer noopener">
        ${texts.nivekiButton}
    </a>`;
    }
    $11990f87f0d79dff$var$logOptimizeEventWidgetShown18to20(booking);
    $11990f87f0d79dff$var$logOptimizeEventWidgetShown(booking);
}
function $11990f87f0d79dff$var$openInNewTab(url) {
    window.open(url, "_blank", "noopener noreferrer");
}
function $11990f87f0d79dff$var$logOptimizeEventWidgetShown18to20(booking) {
    if (booking) return;
    const date = new Date();
    // Do not log on friday (it's until 21.30)
    if (date.getDay() === 5) return;
    const hour = date.getHours();
    // Do not log before 18:00 or after 20:00
    if (hour < 18 || hour > 20) return;
    window.datalayer = window.datalayer || [];
    window.dataLayer.push({
        event: "optimize.widget.shown.18.to.20"
    });
}
function $11990f87f0d79dff$var$logOptimizeEventWidgetShown(booking) {
    if (booking) return;
    window.datalayer = window.datalayer || [];
    window.dataLayer.push({
        event: "optimize.widget.shown"
    });
}
function $11990f87f0d79dff$var$isMobile() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return vw <= 640;
}
function $11990f87f0d79dff$var$isSunday() {
    const today = new Date();
    return today.getDay() === 0;
}
function $11990f87f0d79dff$var$getFromOperatingHour(tenant) {
    const today = new Date();
    if (tenant.operatingHours[today.getDay()] && tenant.operatingHours[today.getDay()].length === 1 && tenant.operatingHours[today.getDay()][0].from) return $11990f87f0d79dff$var$getDisplayTime(tenant.operatingHours[today.getDay()][0].from);
    return null;
}
function $11990f87f0d79dff$var$getToOperatingHour(tenant) {
    const today = new Date();
    if (tenant.operatingHours[today.getDay()] && tenant.operatingHours[today.getDay()].length === 1 && tenant.operatingHours[today.getDay()][0].to) return $11990f87f0d79dff$var$getDisplayTime(tenant.operatingHours[today.getDay()][0].to);
    return null;
}
function $11990f87f0d79dff$var$getDisplayTime(time) {
    const splitTime = time.split(":");
    let timeString = $11990f87f0d79dff$var$removeLeadingZeros(splitTime[0]);
    if (splitTime.length > 1) {
        if ($11990f87f0d79dff$var$removeLeadingZeros(splitTime[1]) > 0) timeString += `:${splitTime[1]}`;
    }
    return timeString;
}
function $11990f87f0d79dff$var$removeLeadingZeros(numString) {
    return parseInt(numString, 10);
}
function $11990f87f0d79dff$var$getShopUrl() {
    let shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) shopUrl = "https://qual-www.micasa.ch/de/p/405750100000/diener";
    return shopUrl;
}
function $11990f87f0d79dff$export$cfae72848eff8ed2() {
    const image = document.querySelector(".lazy");
    if (image) image.classList.remove("lazy");
}
function $11990f87f0d79dff$export$ae6c4758b5042ef8() {
    const video = document.querySelector(".js-beratungshero-popup-video");
    if (video) video.currentTime = 0;
}


var $f643707921ddbfa0$exports = {};
$f643707921ddbfa0$exports = JSON.parse('{"bannerTitle":"<b>Haben Sie weitere Fragen?</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","bannerButton":"Video-Beratung starten","cartButton":"Jetzt verbinden","cartTitle":"<b>Haben Sie Fragen zu Ihrer Bestellung?</b><br /><b>Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent unterst\xfctzen.</b>","configuratorStartPageTitle":"Hilfe beim Konfigurieren","configuratorStartPageSubtitle":"Nutzen Sie zum Konfigurieren unsere Video-Beratung - bequem von zu hause aus.","configuratorStartPageButton":"Videoberatung starten","configuratorStartPageText":"Brauchen Sie Hilfe bei der Konfiguration? Nutzen Sie unsere Video-Beratung: live, kostenlos und unverbindlich.","configuratorStartPageTextOffline":"Brauchen Sie Hilfe bei der Konfiguration? Nutzen Sie unsere Video-Beratung: kostenlos und unverbindlich.","configuratorStartPageLink":"Jetzt Video-Beratung starten","configuratorStartPageLinkOffline":"Jetzt Termin vereinbaren","configuratorConsultant":"Beratung","configuratorButton":"Hilfe? Unsere Video-Beratung unterst\xfctzt Sie","mobileConfiguratorButton":"Zum M\xf6belkonfigurator per Video-Beratung","nivekiTitle":"Wie k\xf6nnen wir Ihnen helfen?","nivekiButton":"Zum Online-Hilfecenter","nivekiButtonLink":{"doitgarden":"https://help.doitgarden.ch/hc/de","melectronics":"https://help.melectronics.ch/hc/de","micasa":"https://help.micasa.ch/hc/de","sportxx":"https://help.sportx.ch/hc/de"},"nivekiButton1":"Ich habe Fragen zu meiner Bestellung","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/contactFormPage","melectronics":"https://www.melectronics.ch/de/cp/contactFormPage","micasa":"https://www.micasa.ch/de/cp/contactFormPage","sportxx":"https://www.sportx.ch/de/cp/contactFormPage"},"nivekiButton1Subtext":"Probleme mit Rechnung, Lieferung, Reparatur...","nivekiButton2":"Ich habe Fragen zum Onlineshop","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/de/categories/360002637600-Vor-meiner-Bestellung","melectronics":"https://help.melectronics.ch/hc/de/categories/360002647099-Vor-meiner-Bestellung","micasa":"https://help.micasa.ch/hc/de/categories/360002637760-Vor-meiner-Bestellung","sportxx":"https://help.sportx.ch/hc/de/categories/360002647659-Vor-meiner-Bestellung"},"nivekiButton2Subtext":"Probleme mit Gutscheinen, Zahlung...","nivekiButton3":"Ich habe Fragen zu meiner Filiale","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/storefinder","melectronics":"https://www.melectronics.ch/de/cp/storefinder","micasa":"https://www.micasa.ch/de/cp/storefinder","sportxx":"https://www.sportx.ch/de/cp/storefinder"},"nivekiButton3Subtext":"Alles \xfcber \xd6ffnungszeiten, Filialbest\xe4nde...","nivekiPrimaryButton":"Video-Beratung starten","nivekiWidgetInfoLink":"So funktioniert die Video-Beratung","stickerButton":{"miocolor":"Video-Beratung vom Farbexperten","default":"Video-Beratung zum Produkt"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Rahmengr\xf6sse via Video-Beratung ermitteln"}},"widgetAvatarTitle":{"miocolor":"Video-Beratung Farbexperte","default":"Video-Beratung"},"widgetAvatarTitleBooking":"Video-Beratung<br />buchen","widgetTitle":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","miocolor":"Live Video-Beratung von unseren Farbexperten","default":"Von Zuhause aus das gleiche Einkaufserlebnis wie in der Filiale!"},"widgetTitleBooking":"Kostenlose Live Video-Beratung vereinbaren.","widgetBodyBullet1":"Ihr Bild wird nicht \xfcbertragen","widgetBodyBooking":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Von Zuhause aus, das gleiche Einkaufserlebnis wie im Laden!"},"widgetButton":{"default":"Jetzt Video-Beratung starten"},"widgetButtonBooking":"Termin vereinbaren","widgetHours":"__FROM__ - __TO__ Uhr","widgetInfoLink":"So funktioniert es","widgetLive":"LIVE","wishlistButton":"Produkte zeigen lassen","widgetSundayToo":"Auch Sonntags!","wishlistTitle":"<b>K\xf6nnen wir Sie bei Ihrer Wahl unterst\xfctzen?</b><br />Alle Produkte k\xf6nnen wir Ihnen bei einem Videogespr\xe4ch live zeigen.","mBudget":{"widget":{"title":"Mit Handy-Abo bis zu 150.- Rabatt f\xfcrs neue Smartphone!","subtitle":"Lassen Sie sich per Video beraten. Ihr Bild wird nicht \xfcbertragen","cta":"Jetzt Video-Beratung starten und profitieren"},"banner":{"title":"<b>Mit Handy-Abo bis zu 150.- Rabatt f\xfcrs neue Smartphone!</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","cta":"Jetzt Video-Beratung starten und profitieren"}}}');


var $43feac846c1f2c6a$exports = {};
$43feac846c1f2c6a$exports = JSON.parse('{"bannerTitle":"<b>Haben Sie weitere Fragen?</b><br />Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent beraten.","bannerButton":"Video-Beratung starten","cartButton":"Jetzt verbinden","cartTitle":"<b>Haben Sie Fragen zu Ihrer Bestellung?</b><br /><b>Wir k\xf6nnen Sie bei einem Videogespr\xe4ch kompetent unterst\xfctzen.</b>","configuratorStartPageTitle":"Hilfe beim Konfigurieren","configuratorStartPageSubtitle":"Nutzen Sie zum Konfigurieren unsere Video-Beratung - bequem von zu hause aus.","configuratorStartPageButton":"Videoberatung starten","configuratorStartPageText":"Do you need help with the configuration? Use our video consultation: live, free of charge and without obligation.","configuratorStartPageTextOffline":"Do you need help with the configuration? Use our video consultation: live, free of charge and without obligation.","configuratorStartPageLink":"Start video consultation","configuratorStartPageLinkOffline":"Book an appointment","configuratorConsultant":"Consulting","configuratorButton":"Hilfe? Unsere Video-Beratung unterst\xfctzt Sie","mobileConfiguratorButton":"Zum M\xf6belkonfigurator per Video-Beratung","nivekiTitle":"How can we help?","nivekiButton":"Online Helpcenter","nivekiButtonLink":{"doitgarden":"https://help.doitgarden.ch/hc/de","melectronics":"https://help.melectronics.ch/hc/de","micasa":"https://help.micasa.ch/hc/de","sportxx":"https://help.sportx.ch/hc/de"},"nivekiButton1":"I have questions about my order","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/contactFormPage","melectronics":"https://www.melectronics.ch/de/cp/contactFormPage","micasa":"https://www.micasa.ch/de/cp/contactFormPage","sportxx":"https://www.sportx.ch/de/cp/contactFormPage"},"nivekiButton1Subtext":"Problems with invoices, deliveries, repairs, etc.","nivekiButton2":"I have questions about the online shop","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/de/categories/360002637600-Vor-meiner-Bestellung","melectronics":"https://help.melectronics.ch/hc/de/categories/360002647099-Vor-meiner-Bestellung","micasa":"https://help.micasa.ch/hc/de/categories/360002637760-Vor-meiner-Bestellung","sportxx":"https://help.sportx.ch/hc/de/categories/360002647659-Vor-meiner-Bestellung"},"nivekiButton2Subtext":"Problems with vouchers, payment, etc.","nivekiButton3":"I have questions about my local store","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/de/cp/storefinder","melectronics":"https://www.melectronics.ch/de/cp/storefinder","micasa":"https://www.micasa.ch/de/cp/storefinder","sportxx":"https://www.sportx.ch/de/cp/storefinder"},"nivekiButton3Subtext":"All you need to know about opening hours, stock, etc.","nivekiPrimaryButton":"Videoberatung starten","nivekiWidgetInfoLink":"So funktioniert die Videoberatung","stickerButton":{"default":"Video-Beratung zum Produkt"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Rahmengr\xf6sse via Video-Beratung ermitteln"}},"widgetAvatarTitle":{"default":"Video advice<br />in English or German"},"widgetAvatarTitleBooking":"Book<br />video advice","widgetTitle":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Video advice in English or German: Connected to our store"},"widgetTitleBooking":"Schedule free live video advice.","widgetBodyBullet1":"You will not be visible.","widgetBodyBooking":{"klubschule":"Unklarheiten? Kein Problem, wir sind f\xfcr Sie da.","default":"Get the same shopping experience at home as at a store!"},"widgetButton":{"default":"Start video advice"},"widgetButtonBooking":"Schedule appointment","widgetHours":"__FROM__-__TO__","widgetInfoLink":"Here\'s how","widgetLive":"LIVE","wishlistButton":"Produkte zeigen lassen","widgetSundayToo":"Even on Sunday!","wishlistTitle":"<b>Can we assist you in choosing in either English or German?</b><br />We can show you any product during a live video chat."}');


var $6ff409eb2f455f75$exports = {};
$6ff409eb2f455f75$exports = JSON.parse('{"bannerTitle":"<b>Vous avez d\'autres questions?</b><br />Nous pouvons vous renseigner directement lors d\'un appel vid\xe9o.","bannerButton":"D\xe9marrer le conseil vid\xe9o","cartButton":"Se connecter","cartTitle":"<b>Avez-vous des questions relatives \xe0 votre commande?</b><br /><b>Nous pouvons vous offrir un conseil comp\xe9tent lors d\u2019un entretien vid\xe9o.</b>","configuratorStartPageTitle":"Aide \xe0 la configuration","configuratorStartPageSubtitle":"Utilisez notre conseil vid\xe9o pour configurer vos meubles, confortablement depuis chez vous.","configuratorStartPageButton":"Lancer le conseil vid\xe9o","configuratorStartPageText":"Besoin d\u2019aide pour la configuration? Profitez de nos conseils vid\xe9o: en direct, gratuitement et sans engagement.","configuratorStartPageTextOffline":"Besoin d\u2019aide pour la configuration? Profitez de nos conseils vid\xe9o: en direct, gratuitement et sans engagement.","configuratorStartPageLink":"D\xe9marrez le conseil vid\xe9o","configuratorStartPageLinkOffline":"Je prends rendez-vous","configuratorConsultant":"Conseil","configuratorButton":"Besoin d\u2019aide? Notre conseil vid\xe9o est \xe0 votre service.","mobileConfiguratorButton":"Conseil vid\xe9o pour configurer ses meubles","nivekiTitle":"En quoi pouvons-nous vous \xeatre utiles?","nivekiButton1":"J\u2019ai des questions sur ma commande","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/fr/cp/contactFormPage","melectronics":"https://www.melectronics.ch/fr/cp/contactFormPage","micasa":"https://www.micasa.ch/fr/cp/contactFormPage","sportxx":"https://www.sportx.ch/fr/cp/contactFormPage"},"nivekiButton1Subtext":"Des probl\xe8mes avec la facture, la livraison...","nivekiButton2":"J\u2019ai des questions sur la boutique en ligne","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/fr/categories/360002637600-Avant-ma-commande","melectronics":"https://help.melectronics.ch/hc/fr/categories/360002647099-Avant-ma-commande","micasa":"https://help.micasa.ch/hc/fr/categories/360002637760-Avant-ma-commande","sportxx":"https://help.sportx.ch/hc/fr/categories/360002647659-Avant-ma-commande"},"nivekiButton2Subtext":"Probl\xe8mes avec des bons, le paiement, r\xe9paration...","nivekiButton3":"J\u2019ai des questions sur mon magasin","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/fr/cp/storefinder","melectronics":"https://www.melectronics.ch/fr/cp/storefinder","micasa":"https://www.micasa.ch/fr/cp/storefinder","sportxx":"https://www.sportx.ch/fr/cp/storefinder"},"nivekiButton3Subtext":"Tout sur les heures d\u2019ouverture, les stocks en magasin...","nivekiPrimaryButton":"Continuer vers les conseils produits","stickerButton":{"default":"Conseil vid\xe9o sur le produit"},"themeSpecific":{"bikeworld":{"sizeTableButton":"D\xe9termination de la taille du cadre par consultation vid\xe9o"}},"widgetAvatarTitle":{"default":"Conseil vid\xe9o"},"widgetAvatarTitleBooking":"R\xe9server un conseil<br />vid\xe9o","widgetTitle":{"klubschule":"Des incertitudes ? Pas de probl\xe8me, nous sommes l\xe0 pour vous.","default":"De chez vous, la m\xeame exp\xe9rience d\'achat qu\'en magasin!"},"widgetTitleBooking":"Planifiez gratuitement un appel vid\xe9o avec un conseiller.","widgetBodyBullet1":"Votre cam\xe9ra ne sera pas active","widgetBodyBooking":{"klubschule":"Des incertitudes ? Pas de probl\xe8me, nous sommes l\xe0 pour vous.","default":"Un contact direct avec votre magasin, sans bouger de chez vous !"},"widgetButton":{"default":"Lancer le conseil vid\xe9o"},"widgetButtonBooking":"Planifier un appel vid\xe9o","widgetHours":"__FROM__ h \xe0 __TO__ h","widgetInfoLink":"Comment \xe7a marche ?","widgetLive":"LIVE","wishlistButton":"Voir les produits en direct","widgetSundayToo":"Aussi Dimanche !","wishlistTitle":"<b>Pouvons-nous vous aider dans votre choix?</b><br />Nous pouvons vous montrer tous les produits en direct lors d\'un appel vid\xe9o.","mBudget":{"widget":{"title":"Avec l\u2019abonnement mobile, jusqu\u2019\xe0 150.- de r\xe9duction pour votre nouveau smartphone!","subtitle":"Faites-vous conseiller par vid\xe9o. Votre cam\xe9ra ne sera pas active","cta":"Lancer le conseil vid\xe9o et en profiter"},"banner":{"title":"<b>Avec l\u2019abonnement mobile, jusqu\u2019\xe0 150.- de r\xe9duction pour votre nouveau smartphone!</b><br />Nous vous conseillons avec comp\xe9tence lors d\u2019un entretien vid\xe9o.","cta":"Lancer le conseil vid\xe9o et en profiter"}}}');


var $cb78fa6868006b8f$exports = {};
$cb78fa6868006b8f$exports = JSON.parse('{"bannerTitle":"<b>Ha altre domande?</b><br />Le possiamo offrire una consulenza competente tramite una conversazione video.","bannerButton":"Comincia la videoconsulenza","cartButton":"Collegare adesso","cartTitle":"<b>Hai domande sulla tua ordinazione?</b><br /><b>Possiamo offrirti una consulenza professionale con una videochiamata.</b>","configuratorStartPageTitle":"Aiuto nella configurazione","configuratorStartPageSubtitle":"Per la configurazione utilizza la nostra videoconsulenza, comodamente da casa tua.","configuratorStartPageButton":"Avvia la videoconsulenza","configuratorStartPageText":"Hai bisogno di aiuto con la configurazione? Utilizza la nostra videoconsulenza: live, gratuita e senza impegno. \u200B","configuratorStartPageTextOffline":"Hai bisogno di aiuto con la configurazione? Utilizza la nostra videoconsulenza: live, gratuita e senza impegno. \u200B","configuratorStartPageLink":"Inizia subito la videoconsulenza","configuratorStartPageLinkOffline":"Fissa ora un appuntamento","configuratorConsultant":"Consulenza","configuratorButton":"Hai bisogno di aiuto? La nostra videoconsulenza \xe8 qui per te","mobileConfiguratorButton":"Al configuratore di mobili tramite videoconsulenza","nivekiTitle":"Come possiamo aiutarti?","nivekiButton1":"Ho domande sulla mia ordinazione","nivekiButton1Link":{"doitgarden":"https://www.doitgarden.ch/it/cp/contactFormPage","melectronics":"https://www.melectronics.ch/it/cp/contactFormPage","micasa":"https://www.micasa.ch/it/cp/contactFormPage","sportxx":"https://www.sportx.ch/it/cp/contactFormPage"},"nivekiButton1Subtext":"Problemi con fattura, consegna, riparazione...","nivekiButton2":"Ho domande sullo shop online","nivekiButton2Link":{"doitgarden":"https://help.doitgarden.ch/hc/it/categories/360002637600-Prima-del-mio-ordine","melectronics":"https://help.melectronics.ch/hc/it/categories/360002647099-Prima-del-mio-ordine","micasa":"https://help.micasa.ch/hc/it/categories/360002637760-Prima-del-mio-ordine","sportxx":"https://help.sportx.ch/hc/it/categories/360002647659-Prima-del-mio-ordine"},"nivekiButton2Subtext":"Problemi con buoni, pagamento...","nivekiButton3":"Ho domande sulla mia filiale","nivekiButton3Link":{"doitgarden":"https://www.doitgarden.ch/it/cp/storefinder","melectronics":"https://www.melectronics.ch/it/cp/storefinder","micasa":"https://www.micasa.ch/it/cp/storefinder","sportxx":"https://www.sportx.ch/it/cp/storefinder"},"nivekiButton3Subtext":"Tutto su orari di apertura, stock filiale...","nivekiPrimaryButton":"Avanti a consulenza prodotti","stickerButton":{"default":"Videoconsulenza sul prodotto"},"themeSpecific":{"bikeworld":{"sizeTableButton":"Determinare la dimensione del telaio tramite consultazione video"}},"widgetAvatarTitle":{"default":"Videoconsulenza"},"widgetAvatarTitleBooking":"Prenota la<br />Videoconsulenza","widgetTitle":{"klubschule":"Incertezze? Nessun problema, siamo qui per voi.","default":"Da casa la stessa esperienza d\u2019acquisto come in negozio!"},"widgetTitleBooking":"Pianificare una consulenza video in diretta gratuita.","widgetBodyBullet1":"La sua immagine non verr\xe0 trasmessa","widgetBodyBooking":{"klubschule":"Incertezze? Nessun problema, siamo qui per voi.","default":"Shopping da casa con la stessa esperienza di acquisto in negozio!"},"widgetButton":{"default":"Comincia la Videoconsulenza"},"widgetButtonBooking":"Fissare un appuntamento","widgetHours":"__FROM__ alle __TO__","widgetInfoLink":"Funziona cosi","widgetLive":"LIVE","wishlistButton":"Mostrare i prodotti","widgetSundayToo":"Anche la domenica!","wishlistTitle":"<b>Desidera la nostra assistenza nella scelta del prodotto?</b><br /> Tutti i prodotti possono essere mostrati LIVE tramite una conversazione video.","mBudget":{"widget":{"title":"Con l\'abbonamento per cellulare fino a 150.- di riduzione sul nuovo smartphone!","subtitle":"Fatti consigliare tramite video. La sua immagine non verr\xe0 trasmessa","cta":"Avvia una videoconsulenza e approfittane"},"banner":{"title":"<b>Con l\'abbonamento per cellulare fino a 150.- di riduzione sul nuovo smartphone!</b><br />Possiamo offrirti una consulenza professionale con una videochiamata.","cta":"Avvia una videoconsulenza e approfittane"}}}');


function $0b060e8a1ef8f2b3$export$b33daf2836bb52dc() {
    /*return "eyJzdHJhdGVneU1lc3NhZ2UiOiJLdW5kZW4sIGRpZSBkaWVzZW4gQXJ0aWtlbCBrYXVmdGVuLCBrYXVmdGVuIGF1Y2giLCJyZWNvbW1lbmRlZFByb2R1Y3RJZHMiOlsiNDAyOTQwNTAwMDAwIiwiNDIwMzc3MDAwMDAwIiwiNDIwNzY1MTAwMDAwIiwiNDMwOTE4NTAwMDgwIiwiNDUwNjI4ODQwNTEwIiwiNDAyMzU5NDAwMDEwIiwiNDUxNjI4NzQzMTIwIiwiNDUwOTA3MTA0MDgwIl19";
   */ const richrelevance = window.RR_DEBUG;
    if (richrelevance && richrelevance.response && richrelevance.response.placements && richrelevance.response.placements[1]) {
        const recommendedProducts = richrelevance.response.placements[1].recommendedProducts;
        const strategyMessage = richrelevance.response.placements[1].strategyMessage;
        const recommendedProductIds = recommendedProducts.map((recommendedProduct)=>recommendedProduct.id);
        const feed = {
            strategyMessage: strategyMessage,
            recommendedProductIds: recommendedProductIds
        };
        return btoa(JSON.stringify(feed));
    }
}




const $b86f4cc7a79985a5$var$MOBILE_CONFIGURATOR_CLASS = "beratungshero--mobile-configurator";
async function $b86f4cc7a79985a5$export$8b96f5ffd2552cf5({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const a = document.createElement("a");
    a.className = $b86f4cc7a79985a5$var$MOBILE_CONFIGURATOR_CLASS;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.href = `${window.BH_URL}/${theme}/${lang}?url=${encodeURIComponent(url)}&consultantId=${consultant._id}&connect=auto&from=mobile-configurator`;
    a.innerHTML = `
  <span>${texts.mobileConfiguratorButton}</span>
  `;
    const anchorElement = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)(".detail-showcase--img-teaser-box");
    if (anchorElement) $b86f4cc7a79985a5$var$insertElement(anchorElement, a);
}
function $b86f4cc7a79985a5$var$insertElement(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement);
    (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("MOBILE_CONFIGURATOR_SHOWN");
    const element = document.querySelector(`.${$b86f4cc7a79985a5$var$MOBILE_CONFIGURATOR_CLASS}`);
    if (element) element.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_MOBILE_CONFIGURATOR_CLICKED");
    };
}
function $b86f4cc7a79985a5$export$a968ef38a9c25187(url) {
    return url.match(/\/(flexa|diener|harrison|indivani|opus|modul|navier|flexcube|till|seven)/);
}




const $15628fa9bba054a9$var$ELEMENT_CLASS = "beratungshero--miocolor-product-finder";
async function $15628fa9bba054a9$export$ee976956fbd973({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const a = document.createElement("a");
    a.className = $15628fa9bba054a9$var$ELEMENT_CLASS;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.href = `${window.BH_URL}/${theme}/${lang}?url=${encodeURIComponent(url)}&consultantId=${consultant._id}&connect=auto`;
    a.innerHTML = `
  <span>${texts.stickerButton[theme] || texts.stickerButton.default}</span>
  `;
    const clearDiv = document.createElement("div");
    clearDiv.style = "clear: both;";
    const anchorElement = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)("#smartassistant-advisor");
    if (anchorElement) {
        $15628fa9bba054a9$var$insertElement(anchorElement, a);
        $15628fa9bba054a9$var$insertElement(anchorElement, clearDiv);
        $15628fa9bba054a9$var$addLogging();
    }
}
function $15628fa9bba054a9$var$insertElement(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement);
}
function $15628fa9bba054a9$var$addLogging() {
    (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("MIOCOLOR_PRODUCT_FINDER_SHOWN");
    const element = document.querySelector(`.${$15628fa9bba054a9$var$ELEMENT_CLASS}`);
    if (element) element.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("MIOCOLOR_PRODUCT_FINDER_CLICKED");
    };
}
function $15628fa9bba054a9$export$251da56a2383494d(url) {
    return url.match(/\/cp\/produktfinder-malen/);
}





const $dbe910081c39d7da$var$THEME = "klubschule";
function $dbe910081c39d7da$export$7a3dda2e253d264c({ url: url, consultant: consultant, lang: lang }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const div = (0, $1b115c651245dfe5$export$477d3f7871bc78f7)({
        url: url,
        consultant: consultant,
        theme: $dbe910081c39d7da$var$THEME,
        lang: lang,
        text: texts.bannerTitle,
        buttonText: `<span>${texts.bannerButton}</span>`
    });
    (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)(".ksm-course-static-button").then((primaryButton)=>{
        if (primaryButton) {
            // insert after primaryButton
            primaryButton.parentNode.insertBefore(div, primaryButton.nextSibling);
            (0, $1b115c651245dfe5$export$8e6a1541577e86a7)("BUTTON_BANNER_CLICKED");
        }
    });
}





const $7f64fd1f94e99f46$var$THEME = "bikeworld";
const $7f64fd1f94e99f46$var$SIZE_TABLE_ELEMENT_CLASS = "beratungshero-button beratungshero-button--secondary-inverted beratungshero-button--size-table";
function $7f64fd1f94e99f46$export$7a3dda2e253d264c({ url: url, consultant: consultant, lang: lang }) {
    (0, $330d32d652193a23$export$92413a7c60d15e8a)(url, "bikes");
}
async function $7f64fd1f94e99f46$var$createSizeTableElement({ url: url, consultant: consultant, theme: theme, lang: lang }) {
    const texts = (0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang);
    const a = document.createElement("a");
    a.id = "beratungshero-size-table-button";
    a.className = $7f64fd1f94e99f46$var$SIZE_TABLE_ELEMENT_CLASS;
    a.style.marginTop = "-9px";
    a.style.marginBottom = "16px";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.href = `${window.BH_URL}/${theme}/${lang}?url=${encodeURIComponent(url)}&consultantId=${consultant._id}&connect=auto&from=size-table`;
    a.innerHTML = `
  <span>${texts.themeSpecific[$7f64fd1f94e99f46$var$THEME].sizeTableButton}</span>
  `;
    const optionBoxElement = await (0, $bd64aa99694b6ef2$export$d16800b7e59a8051)("#detail_variant_option_box");
    if (optionBoxElement) {
        const anchorElement = optionBoxElement.nextSibling;
        if (anchorElement) $7f64fd1f94e99f46$var$insertElementAfter(anchorElement, a);
    }
}
function $7f64fd1f94e99f46$var$insertElementAfter(anchorElement, elementToInsert) {
    anchorElement.parentNode.insertBefore(elementToInsert, anchorElement.nextSibling);
    (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("SIZE_TABLE_SHOWN");
    const element = document.querySelector("#beratungshero-size-table-button");
    if (element) element.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_SIZE_TABLE_CLICKED");
    };
}





const $b0d4760db209c883$var$liveStreamTimes = [
    {
        from: "2022-08-22T20:00:00+02:00",
        to: "2022-08-22T21:15:00+02:00"
    },
    {
        from: "2022-08-29T20:00:00+02:00",
        to: "2022-08-29T21:30:00+02:00"
    }
];
function $b0d4760db209c883$export$2c1f72e574bfe8b9(tenant, lang) {
    if (tenant !== "sportxx" || lang !== "de") return;
    const url = new URL(document.location.href);
    if (url.searchParams.get("liveStream")) return true;
    if (url.pathname.startsWith("/de")) {
        const now = new Date();
        return $b0d4760db209c883$var$liveStreamTimes.find((x)=>new Date(x.from) < now && now < new Date(x.to));
    }
}
function $b0d4760db209c883$export$6f843df447d8d0e2(showId) {
    (function() {
        if (!window.initBambuserLiveShopping) {
            window.initBambuserLiveShopping = function(item) {
                window.initBambuserLiveShopping.queue.push(item);
            };
            window.initBambuserLiveShopping.queue = [];
            var scriptNode = document.createElement("script");
            scriptNode["src"] = "https://lcx-embed.bambuser.com/powered-by-bambuser-theme/embed.js";
            document.body.appendChild(scriptNode);
        }
        window.initBambuserLiveShopping({
            showId: showId,
            type: "overlay"
        });
    })();
}
document.body.addEventListener("click", (e)=>{
    if (e.target.tagName === "A") {
        const hrefParts = e.target.hash.split("_");
        if (hrefParts[0] === "#vbLiveStream") {
            const id = hrefParts[1];
            console.log("open live stream with id", id);
            $b0d4760db209c883$export$6f843df447d8d0e2(id);
        }
    }
});
// const url = new URL(document.location.href);
// if (url.searchParams.get("vbLiveStream") === "play") {
//   const liveStreamLinks = document.querySelectorAll(
//     "a[href^='#vbLiveStream_']"
//   );
//   if (liveStreamLinks.length > 0) {
//     const hrefParts = liveStreamLinks[0].hash.split("_");
//     const id = hrefParts[1];
//     console.log("open live stream with id", id);
//     initBambuserOverlay(id);
//   }
// }
let $b0d4760db209c883$var$lastTrackingPoint;
let $b0d4760db209c883$var$interval;
let $b0d4760db209c883$var$currentShow;
function $b0d4760db209c883$var$startTrackViewTime(showId) {
    if ($b0d4760db209c883$var$currentShow) {
        if ($b0d4760db209c883$var$currentShow !== showId) $b0d4760db209c883$var$stopTrackViewTime($b0d4760db209c883$var$currentShow);
        else return;
    }
    if ($b0d4760db209c883$var$interval) clearInterval($b0d4760db209c883$var$interval);
    $b0d4760db209c883$var$lastTrackingPoint = new Date().getTime();
    $b0d4760db209c883$var$currentShow = showId;
    $b0d4760db209c883$var$interval = setInterval(()=>{
        $b0d4760db209c883$var$trackCurrentProgress(showId);
    }, 15000);
}
function $b0d4760db209c883$var$stopTrackViewTime(showId) {
    if (showId !== $b0d4760db209c883$var$currentShow) return;
    $b0d4760db209c883$var$trackCurrentProgress(showId);
    clearInterval($b0d4760db209c883$var$interval);
    $b0d4760db209c883$var$currentShow = undefined;
    $b0d4760db209c883$var$lastTrackingPoint = undefined;
}
function $b0d4760db209c883$var$trackCurrentProgress(showId, sendEvent = true) {
    if (showId !== $b0d4760db209c883$var$currentShow) return;
    const trackingPoint = new Date().getTime();
    const currentWatchTime = parseFloat(window.sessionStorage.getItem("watchTime#" + showId)) || 0;
    const newWatchTime = currentWatchTime + (trackingPoint - $b0d4760db209c883$var$lastTrackingPoint) / 1000;
    $b0d4760db209c883$var$lastTrackingPoint = trackingPoint;
    window.sessionStorage.setItem("watchTime#" + showId, newWatchTime);
    if (sendEvent) $b0d4760db209c883$var$liveStreamEvent({
        eventName: "WATCH_TIME",
        showId: showId,
        value: Math.floor(newWatchTime)
    });
}
function $b0d4760db209c883$var$getCurrentWatchTime(showId) {
    if (showId === $b0d4760db209c883$var$currentShow) $b0d4760db209c883$var$trackCurrentProgress(showId, false);
    return parseInt(window.sessionStorage.getItem("watchTime#" + showId)) || 0;
}
// window.addEventListener("bambuser-liveshop-tracking-point", ({ detail }) => {
//   if (detail.event === "on-play") {
//     startTrackViewTime(detail.data.showId);
//   }
//   if (detail.event === "on-stop") {
//     stopTrackViewTime(detail.data.showId);
//   }
//   if (detail.event === "on-interaction") {
//     if (detail.data.interactionType === "pause") {
//       stopTrackViewTime(detail.data.showId);
//     } else if (detail.data.interactionType === "resume") {
//       startTrackViewTime(detail.data.showId);
//     } else if (detail.data.interactionType === "close") {
//       stopTrackViewTime(detail.data.showId);
//     }
//   }
//   let eventName = toEventName(detail.event).replace(/^ON_/, "");
//   switch (eventName) {
//     case "INTERACTION":
//       eventName = toEventName(detail.data.interactionType);
//   }
//   const watchTime = getCurrentWatchTime(detail.data.showId);
//   liveStreamEvent({
//     eventName,
//     showId: detail.data.showId,
//     value: watchTime ? watchTime : undefined
//   });
// });
// window.addEventListener("message", (e) => {
//   if (e.data) {
//     try {
//       const data = JSON.parse(e.data);
//       if (data.eventName === "liveshopping-widget:tracking") {
//         let eventName = toEventName(data.data.eventType).replace(/^ON_/, "");
//         switch (eventName) {
//           case "INTERACTION":
//             eventName = toEventName(data.data.interactionType);
//         }
//         liveStreamEvent({
//           eventName: "WIDGET_" + eventName,
//           showId: data.data.showId
//         });
//       }
//     } catch (e) {
//       // Ignore if json cannot be parsed
//     }
//   }
// });
function $b0d4760db209c883$var$liveStreamEvent({ eventName: eventName, showId: showId, value: value }) {
    (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("LIVESTREAM_" + eventName, {
        showId: showId
    }, value);
}
function $b0d4760db209c883$var$toEventName(value) {
    return value.replace(/[:-]/g, "_").toUpperCase();
}




/**
 * Get the inner html content for the banner.
 * @param {string} avatarImageUrl avatar image url
 * @param {string} beratungsLink beratungs link
 * @param {object} texts translation texts
 * @returns {string} html content
 */ function $267cf33bc19d6f05$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts) {
    const isSmartphone = (0, $1a19ad51aa7d708b$export$3c89af888305343f)(document.location.href);
    return `
    <div class="beratungshero--banner beratungshero--banner--pdp">
      <div class="beratungshero--avatar-container">
        <img alt="" src="${avatarImageUrl}" />
        <div class="beratungshero--avatar-live">
          ${texts.widgetLive}
        </div>
      </div>
      <div class="beratungshero--body beratungshero--body--pdp">
        <div class="beratungshero--left">
          <div class="beratungshero--text">
            <div class="beratungshero--title">
              ${isSmartphone ? texts.mBudget.banner.title : texts.bannerTitle}
            </div>
            <div class="beratungshero-list">
              <div class="beratungshero--list-item beratungshero--list-item--pdp">
                ${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${texts.widgetBodyBullet1}
              </div>
            </div>
          </div>
        </div>
        <div class="beratungshero--buttons beratungshero--buttons--pdp beratungshero--buttons-center">
          <a id="beratungshero-banner-video" class="beratungshero--more" href="${beratungsLink}" target="_blank" rel="noopener noreferrer">
            <span>
              ${isSmartphone ? texts.mBudget.banner.cta : texts.bannerButton}
            </span>
          </a>
        </div>
      </div>
    </div>`;
}
function $267cf33bc19d6f05$export$2e2bcd8739ae039(texts, tenant, lang, avatarImageUrl, consultant) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.mBudget.banner.title) throw new Error("texts.mBudget.banner.title is required");
    if (!texts.mBudget.banner.cta) throw new Error("texts.mBudget.banner.cta is required");
    if (!texts.bannerTitle) throw new Error("texts.bannerTitle is required");
    if (!texts.bannerButton) throw new Error("texts.bannerButton is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    if (!texts.widgetBodyBullet1) throw new Error("texts.widgetBodyBullet1 is required");
    if (!lang) throw new Error("lang is required");
    if (!avatarImageUrl) throw new Error("avatarImageUrl is required");
    if (!consultant) throw new Error("consultant is required");
    const urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
    urlParams.append("consultantId", consultant._id);
    const finalLang = lang === "en" ? "de" : lang;
    const beratungsLink = `${window.BH_URL}/${tenant}/${finalLang}?${urlParams.toString()}`;
    const div = document.createElement("div");
    div.className = "beratungshero--root p-product-detail--item p-product-detail--item__details detail-navigation-section";
    div.innerHTML = $267cf33bc19d6f05$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts);
    return div;
}




/**
 * Create a sticker a tag to inject into the dom.
 * @param {Object} texts
 * @param {string} texts.stickerButton
 * @param {string} texts.widgetLive
 * @param {string} tenant
 * @returns {string}
 * @example
 * getInnerHtmlContent(texts, tenant);
 * @example
 * getInnerHtmlContent(texts, "bikeworld");
 */ function $494a8b28cc7946c2$var$getInnerHtmlContent(texts, tenant) {
    return `<span>${texts.stickerButton[tenant] || texts.stickerButton.default}</span><span class="beratungshero--sticker-live">${texts.widgetLive}</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>`;
}
function $494a8b28cc7946c2$export$2e2bcd8739ae039(texts, tenant) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.stickerButton) throw new Error("texts.stickerButton is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    const a = document.createElement("a");
    a.className = "js__beratungshero--sticker beratungshero--sticker";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.innerHTML = $494a8b28cc7946c2$var$getInnerHtmlContent(texts, tenant);
    a.onclick = function() {
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_STICKER_CLICKED");
        (0, $bd64aa99694b6ef2$export$5009e7f3fa7b4cd3)("beratungshero_button_sticker_clicked");
    };
    return a;
}



/**
 * Get the inner html content for the wishlist banner.
 * @param {string} avatarImageUrl avatar image url
 * @param {string} beratungsLink beratungs link
 * @param {object} texts translation texts
 * @returns {string} html content
 */ function $e6e94e0d5de1d111$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts) {
    const div = document.createElement("div");
    div.className = "wishlist--container";
    div.innerHTML = `
  <div class="beratungshero--banner">
    <div class="beratungshero--avatar-container">
      <img alt="" src="${avatarImageUrl}" />
      <div class="beratungshero--avatar-live">${texts.widgetLive}</div>
    </div>
    <div class="beratungshero--body">
      <div class="beratungshero--left">
        <div class="beratungshero--text">
          <div class="beratungshero--title">
            ${texts.wishlistTitle}
          </div>
          <div class="beratungshero-list">
            <div class="beratungshero--list-item">
              ${0, $773b60ff9ada0e5d$export$ead18583963a4390} ${texts.widgetBodyBullet1}
            </div>
          </div>
        </div>
      </div>
      <div class="beratungshero--buttons beratungshero--buttons-center">
        <a id="beratungshero-banner-video" class="beratungshero--more" href="${beratungsLink}" target="_blank" rel="noopener noreferrer">
          <span>${texts.wishlistButton}</span>
        </a>
      </div>
    </div>
  </div>
  `;
    return div;
}
function $e6e94e0d5de1d111$export$2e2bcd8739ae039(texts, tenant, lang, avatarImageUrl, consultantId) {
    if (!tenant) throw new Error("tenant is required");
    if (!texts) throw new Error("texts is required");
    if (!texts.widgetLive) throw new Error("texts.widgetLive is required");
    if (!texts.wishlistTitle) throw new Error("texts.wishlistTitle is required");
    if (!texts.widgetBodyBullet1) throw new Error("texts.widgetBodyBullet1 is required");
    if (!texts.wishlistButton) throw new Error("texts.wishlistButton is required");
    if (!lang) throw new Error("lang is required");
    if (!avatarImageUrl) throw new Error("avatarImageUrl is required");
    const urlParams = new URLSearchParams();
    urlParams.append("connect", "auto");
    urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
    urlParams.append("consultantId", consultantId);
    const finalLang = lang === "en" ? "de" : lang;
    const beratungsLink = `${window.BH_URL}/${tenant}/${finalLang}?${urlParams.toString()}`;
    const wishlistBanner = document.createElement("div");
    wishlistBanner.appendChild($e6e94e0d5de1d111$var$getInnerHtmlContent(avatarImageUrl, beratungsLink, texts));
    return wishlistBanner;
}


/**
 * Cached data from the last widget data fetch. It contains the widget data and the timestamp of the fetch.
 * @type {Object}
 * @property {Object} data - The widget data.
 * @property {string} lang - The language of the widget data.
 * @property {number} timestamp - The timestamp of the fetch.
 */ let $a16476215b1dd274$var$cachedData;
async function $a16476215b1dd274$export$2e2bcd8739ae039(lang, tenant) {
    if (!("fetch" in window)) return;
    // Check if we have cached data and that the cached data is not to old and of the same language. If the check is true we return the cached data.
    if ($a16476215b1dd274$var$cachedData && $a16476215b1dd274$var$cachedData.lang === lang && $a16476215b1dd274$var$cachedData.timestamp + 120000 > Date.now()) return $a16476215b1dd274$var$cachedData.data;
    try {
        const data = await (await fetch(`${window.BH_URL}/api/widget-enabled?rootTheme=${tenant}&theme=${tenant}&lang=${lang}`)).json();
        $a16476215b1dd274$var$cachedData = {
            data: data,
            lang: lang,
            timestamp: Date.now()
        };
        return $a16476215b1dd274$var$cachedData.data;
    } catch (error) {
        console.error(error);
    }
}


const $e6beb0d03b171f70$export$6242eb21763d4a88 = [
    "bikeworld",
    "doitgarden",
    "micasa",
    "melectronics",
    "sportxx",
    "sportx"
];




function $1d0dd590af5ac34e$export$2e2bcd8739ae039(anchor, config) {
    if (!anchor) throw new Error("No anchor element provided.");
    if (!config) throw new Error("No config object provided.");
    if (!config.lang) throw new Error("No language provided.");
    if (!config.tenant) throw new Error("No tenant provided.");
    if (!(0, $e6beb0d03b171f70$export$6242eb21763d4a88).includes(config.tenant)) throw new Error("Invalid tenant provided.");
}






async function $7f261094d30e6c24$export$2e2bcd8739ae039(anchor, config) {
    (0, $1d0dd590af5ac34e$export$2e2bcd8739ae039)(anchor, config);
    try {
        const { lang: lang, tenant: tenant } = config;
        if ((0, $bd64aa99694b6ef2$export$bfb231a5a6aca5de)(tenant)) return;
        const { consultant: consultant, duringOfficeHours: duringOfficeHours, consultantAvailable: consultantAvailable, tenant: tenantData } = await (0, $a16476215b1dd274$export$2e2bcd8739ae039)(lang, tenant);
        const { touchpoints: touchpoints } = tenantData;
        if (touchpoints && touchpoints.banner && touchpoints.banner.enabled !== undefined && !touchpoints.banner.enabled) return;
        if (!duringOfficeHours || !consultantAvailable) return;
        if (!consultant || !consultant._id) throw new Error("No consultant found");
        let avatarImageUrl = consultant.imageAvatar;
        if (avatarImageUrl.indexOf("https://") === 0) avatarImageUrl = avatarImageUrl.replace("upload/", "upload/w_240/");
        else avatarImageUrl = window.BH_URL + avatarImageUrl;
        const banner = (0, $267cf33bc19d6f05$export$2e2bcd8739ae039)((0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang), tenant, lang, avatarImageUrl, consultant);
        anchor.appendChild(banner);
        const moreLink = document.querySelector("#beratungshero-banner-video");
        moreLink.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_BANNER_CLICKED");
        };
    } catch (err) {
        console.error(err);
    }
}





async function $73827848afd8cfc5$export$2e2bcd8739ae039(anchor, config) {
    (0, $1d0dd590af5ac34e$export$2e2bcd8739ae039)(anchor, config);
    try {
        const { lang: lang, tenant: tenant } = config;
        if ((0, $bd64aa99694b6ef2$export$bfb231a5a6aca5de)(tenant)) return;
        const { consultant: consultant, duringOfficeHours: duringOfficeHours, consultantAvailable: consultantAvailable, tenant: tenantData } = await (0, $a16476215b1dd274$export$2e2bcd8739ae039)(lang, tenant);
        const { touchpoints: touchpoints } = tenantData;
        if (touchpoints && touchpoints.sticker && touchpoints.sticker.enabled !== undefined && !touchpoints.sticker.enabled) return;
        if (!duringOfficeHours || !consultantAvailable) return;
        if (!consultant || !consultant._id) throw new Error("No consultant found");
        const sticker = (0, $494a8b28cc7946c2$export$2e2bcd8739ae039)((0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang), tenant);
        const urlParams = new URLSearchParams();
        urlParams.append("url", encodeURIComponent(document.location.href.split("#")[0]));
        urlParams.append("consultantId", consultant._id);
        urlParams.append("source", "sticker");
        const finalLang = lang === "en" ? "de" : lang;
        sticker.href = `${window.BH_URL}/${tenant}/${finalLang}?${urlParams.toString()}`;
        anchor.appendChild(sticker);
        (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("STICKER_SHOWN");
    } catch (error) {
        console.error(error);
    }
}





async function $5eb86eb81955a43c$export$2e2bcd8739ae039(anchor, config) {
    (0, $1d0dd590af5ac34e$export$2e2bcd8739ae039)(anchor, config);
    try {
        const { lang: lang, tenant: tenant } = config;
        if ((0, $bd64aa99694b6ef2$export$bfb231a5a6aca5de)(tenant)) return;
        const { consultant: consultant, duringOfficeHours: duringOfficeHours, consultantAvailable: consultantAvailable } = await (0, $a16476215b1dd274$export$2e2bcd8739ae039)(lang, tenant);
        if (!duringOfficeHours || !consultantAvailable) return;
        if (!consultant || !consultant._id) throw new Error("No consultant found");
        let avatarImageUrl = consultant.imageAvatar;
        if (avatarImageUrl.indexOf("https://") === 0) avatarImageUrl = avatarImageUrl.replace("upload/", "upload/w_240/");
        else avatarImageUrl = window.BH_URL + avatarImageUrl;
        const banner = (0, $e6e94e0d5de1d111$export$2e2bcd8739ae039)((0, $1a19ad51aa7d708b$export$f25f608cf887c8b)(lang), tenant, lang, avatarImageUrl, consultant._id);
        anchor.appendChild(banner);
        const moreLink = document.querySelector("#beratungshero-banner-video");
        moreLink.onclick = function() {
            (0, $1a19ad51aa7d708b$export$5e9eec8001665ac5)("BUTTON_WISHLIST_CLICKED");
        };
    } catch (err) {
        console.error(err);
    }
}




const $1a19ad51aa7d708b$var$DEBUG = false;
const $1a19ad51aa7d708b$var$POPUP_ENLARGED_COOKIE_NAME = "onlineberatung-enlarged";
const $1a19ad51aa7d708b$var$THROTTLED_COOKIE_NAME = "onlineberatung-throttled";
const $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_DEFAULT = 30000;
const $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_PRODUCT = 3000000;
let $1a19ad51aa7d708b$var$from = null;
window.BH_BAMBUSER_CLOSE = false;
window.addEventListener("message", (e)=>{
    if (e.data === "BH_BAMBUSER_CLOSED") {
        window.BH_BAMBUSER_CLOSE = true;
        $1a19ad51aa7d708b$var$currentUrl = document.location.href.split("#")[0];
        const { theme: theme, lang: lang } = $1a19ad51aa7d708b$var$getThemeAndLang($1a19ad51aa7d708b$var$currentUrl);
        $1a19ad51aa7d708b$var$handlePageChange({
            url: $1a19ad51aa7d708b$var$currentUrl,
            delay: $1a19ad51aa7d708b$var$delay,
            theme: theme,
            lang: lang
        });
    }
});
function $1a19ad51aa7d708b$var$supportsWebRTC() {
    const isWebRTCSupported = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || window.RTCPeerConnection;
    if (window.navigator.userAgent.indexOf("Edge") > -1) return false;
    if (isWebRTCSupported) return true;
    else return false;
}
function $1a19ad51aa7d708b$export$5e9eec8001665ac5(event, options = null, value) {
    const evt = {
        event: "beratungshero",
        beratungsheroEvent: event,
        beratungsheroOption: options ? Object.values(options).join(",") : undefined,
        beratungsheroValue: value || undefined
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evt);
    if ($1a19ad51aa7d708b$var$DEBUG) console.log(event);
}
function $1a19ad51aa7d708b$export$f25f608cf887c8b(lang) {
    switch(lang){
        case "fr":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6ff409eb2f455f75$exports));
        case "it":
            return 0, (/*@__PURE__*/$parcel$interopDefault($cb78fa6868006b8f$exports));
        case "en":
            return 0, (/*@__PURE__*/$parcel$interopDefault($43feac846c1f2c6a$exports));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($f643707921ddbfa0$exports));
    }
}
function $1a19ad51aa7d708b$export$3c89af888305343f(url) {
    let isOfCategory = false;
    if ((0, $330d32d652193a23$export$a6ee0f0139d9689a)(url) && window.dataLayer) window.dataLayer.forEach((item)=>{
        if (item.ecommerce && item.ecommerce.impressions) {
            const categoryUrl = item.ecommerce.impressions[0].category;
            if (categoryUrl.match("/smartphone")) isOfCategory = true;
        }
    });
    if (isOfCategory) return true;
    return url.match(/\/(smartphone)/);
}
function $1a19ad51aa7d708b$var$isBannedPage(url, theme, lang) {
    let banned = false;
    if ((0, $330d32d652193a23$export$ab20bca5abfae9b7)(url)) banned = true;
    if ((0, $330d32d652193a23$export$a6ee0f0139d9689a)(url) && window.dataLayer) window.dataLayer.forEach((item)=>{
        if (item.ecommerce && item.ecommerce.detail && item.ecommerce.detail.products && item.ecommerce.detail.products[0] && item.ecommerce.detail.products[0].category) {
            const categoryUrl = item.ecommerce.detail.products[0].category;
            if (categoryUrl.match("/lust-liebe") || categoryUrl.match("/spielwaren")) banned = true;
        }
    });
    if ((0, $330d32d652193a23$export$3ee1ac535276712)(url)) banned = true;
    if (banned) return true;
    if ($1a19ad51aa7d708b$var$hasLiveShoppingElement()) return true;
    if ((0, $b0d4760db209c883$export$2c1f72e574bfe8b9)(theme, lang)) return true;
    // check if we are on heimberatung or einrichtungsberatung page and lang is not de to hide widget
    const isUrlEinrichtungOrHeimberatung = url.match(/\/(einrichtungsberatung)/) || url.match(/\/(heimberatung)/);
    if (isUrlEinrichtungOrHeimberatung && lang !== "de") return true;
    // Check if we are in an iframe, e.g. when the mini-player is active
    if (!window.BH_BAMBUSER_CLOSE && window.self !== window.top) return true;
    return url.match(/\/(cart|checkout|contact|storefinder|lust-liebe|plaisir-et-amour|Singles-Day|singles-day|spielwaren|dailydeal|big-win)/);
}
function $1a19ad51aa7d708b$var$hasLiveShoppingElement() {
    return !!document.querySelector(".liveShopping");
}
let $1a19ad51aa7d708b$var$updateRichrelevanceFeedInterval;
let $1a19ad51aa7d708b$var$miocolorWidgetCreated = false;
function $1a19ad51aa7d708b$var$handlePageChange({ url: url, delay: delay, theme: theme, lang: lang }) {
    let root = document.querySelector(".beratungshero--root");
    const hide = $1a19ad51aa7d708b$var$isBannedPage(url, theme, lang);
    // if (isLiveStreamActive(theme, lang)) {
    //   initBambuserFloatingButton();
    // }
    if (root) {
        root.style.display = hide ? "none" : "block";
        if (hide) return;
    }
    // Handle change to miocolor theme
    const { theme: newTheme, lang: newLang } = $1a19ad51aa7d708b$var$getThemeAndLang(url);
    theme = newTheme;
    lang = newLang;
    if ($1a19ad51aa7d708b$var$isThrottled()) return;
    $1a19ad51aa7d708b$var$checkIfEnabled(function(consultant, booking, bookingLink, landingPageUrl, tenant) {
        var _window_BH, _window;
        const theme = tenant.name;
        // check if changing from booking to normal widget or vice versa
        const bookingWidgetShown = !!document.querySelector(".beratungshero--booking");
        if (consultant && bookingWidgetShown || booking && !bookingWidgetShown) // remove widget, right widget is added below
        {
            if (root) {
                root.remove();
                root = null;
                (0, $e5d437f86f4d95b1$export$eb1d1800c11907c2)();
                $1a19ad51aa7d708b$var$stylesAdded = false;
            }
        }
        if ($1a19ad51aa7d708b$var$isBannedPage(url, theme, lang) && root) {
            root.style.display = "none";
            return;
        }
        const widgetPosition = (_window = window) === null || _window === void 0 ? void 0 : (_window_BH = _window.BH) === null || _window_BH === void 0 ? void 0 : _window_BH.widgetPosition;
        if (theme === "miocolor") {
            if (!hide) $1a19ad51aa7d708b$export$5e9eec8001665ac5("MIOCOLOR_WIDGET_SHOWN");
            if (!$1a19ad51aa7d708b$var$miocolorWidgetCreated) {
                if (root) {
                    root.remove();
                    root = null;
                    (0, $e5d437f86f4d95b1$export$eb1d1800c11907c2)();
                    $1a19ad51aa7d708b$var$stylesAdded = false;
                }
                if (!$1a19ad51aa7d708b$var$stylesAdded) {
                    (0, $e5d437f86f4d95b1$export$31f077b88a3c784c)(theme, lang);
                    $1a19ad51aa7d708b$var$stylesAdded = true;
                }
                const variant = $1a19ad51aa7d708b$var$getVariant(theme);
                (0, $11990f87f0d79dff$export$d856f5947026c431)({
                    consultant: consultant,
                    theme: theme,
                    lang: lang,
                    variant: variant,
                    hidden: hide,
                    booking: booking,
                    bookingLink: bookingLink,
                    landingPageUrl: landingPageUrl,
                    tenant: tenant,
                    position: widgetPosition,
                    widgetType: window.BH.widgetType,
                    popupVideoUrl: window.BH.popupVideoUrl,
                    from: $1a19ad51aa7d708b$var$from,
                    url: url
                });
                $1a19ad51aa7d708b$var$miocolorWidgetCreated = true;
            } else $1a19ad51aa7d708b$var$updatePopupPrimaryButtonShopUrl();
        } else {
            if ($1a19ad51aa7d708b$var$miocolorWidgetCreated) {
                if (root) {
                    root.remove();
                    root = null;
                    $1a19ad51aa7d708b$var$miocolorWidgetCreated = false;
                    (0, $e5d437f86f4d95b1$export$eb1d1800c11907c2)();
                    $1a19ad51aa7d708b$var$stylesAdded = false;
                }
            }
            if (!root) {
                if (!hide) $1a19ad51aa7d708b$export$5e9eec8001665ac5("WIDGET_SHOWN");
                if (booking) {
                    if (!hide) $1a19ad51aa7d708b$export$5e9eec8001665ac5("WIDGET_APPOINTMENT_SHOWN");
                }
                if (!$1a19ad51aa7d708b$var$stylesAdded) {
                    (0, $e5d437f86f4d95b1$export$31f077b88a3c784c)(theme, lang);
                    $1a19ad51aa7d708b$var$stylesAdded = true;
                }
                const variant = $1a19ad51aa7d708b$var$getVariant(theme);
                (0, $11990f87f0d79dff$export$d856f5947026c431)({
                    consultant: consultant,
                    theme: theme,
                    lang: lang,
                    variant: variant,
                    hidden: hide,
                    booking: booking,
                    bookingLink: bookingLink,
                    landingPageUrl: landingPageUrl,
                    tenant: tenant,
                    position: widgetPosition,
                    widgetType: window.BH.widgetType,
                    popupVideoUrl: window.BH.popupVideoUrl,
                    from: $1a19ad51aa7d708b$var$from,
                    url: url
                });
            } else $1a19ad51aa7d708b$var$updatePopupPrimaryButtonShopUrl();
        }
        switch(theme){
            case "klubschule":
                (0, $dbe910081c39d7da$export$7a3dda2e253d264c)({
                    url: url,
                    consultant: consultant,
                    lang: lang
                });
                break;
            case "bikeworld":
                (0, $7f64fd1f94e99f46$export$7a3dda2e253d264c)({
                    url: url,
                    consultant: consultant,
                    lang: lang
                });
                break;
        }
        if ($1a19ad51aa7d708b$var$updateRichrelevanceFeedInterval) clearInterval($1a19ad51aa7d708b$var$updateRichrelevanceFeedInterval);
        if (!booking && (0, $330d32d652193a23$export$a6ee0f0139d9689a)(url)) $1a19ad51aa7d708b$var$updateRichrelevanceFeedInterval = setInterval($1a19ad51aa7d708b$var$updateRichrelevanceFeed, 5000);
        if (theme === "klubschule") {
            $1a19ad51aa7d708b$var$enlargePopup({
                delay: $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_DEFAULT,
                theme: theme,
                lang: lang
            });
            return;
        }
        if (theme === "melectronics" && $1a19ad51aa7d708b$export$3c89af888305343f(url)) {
            $1a19ad51aa7d708b$var$enlargePopup({
                delay: $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_DEFAULT,
                theme: theme,
                lang: lang
            });
            return;
        }
        const uri = new URL(url);
        if (theme === "micasa" && uri.href.includes("einrichtungsberatung")) $1a19ad51aa7d708b$var$enlargePopup({
            delay: 10000,
            theme: theme,
            lang: lang
        });
        if (theme === "micasa" && uri.href.includes("heimberatung")) $1a19ad51aa7d708b$var$enlargePopup({
            delay: 10000,
            theme: theme,
            lang: lang
        });
        if ((0, $330d32d652193a23$export$47b4274c3eda8f60)(url) && !booking) {
            (0, $1b115c651245dfe5$export$25c216e52ab8fda1)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if ((0, $330d32d652193a23$export$fe63f8185eda093c)(url) && !booking) {
            (0, $1b115c651245dfe5$export$34b442c3d073f811)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if (theme === "miocolor" && (0, $15628fa9bba054a9$export$251da56a2383494d)(url)) {
            (0, $15628fa9bba054a9$export$ee976956fbd973)({
                url: url,
                consultant: consultant,
                theme: theme,
                lang: lang
            });
            return;
        }
        if ((0, $330d32d652193a23$export$a6ee0f0139d9689a)(url) && !$1a19ad51aa7d708b$var$isBannedPage(url, theme, lang)) {
            // enlarge popup also for booking appointment
            $1a19ad51aa7d708b$var$enlargePopup({
                delay: delay,
                theme: theme,
                lang: lang
            });
            if (!booking) {
                $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.sticker.show");
                (0, $cf813d967187b691$export$752ff9cccbcd133d)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
                (0, $1b115c651245dfe5$export$596743d694fcb1b6)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
                if (theme === "micasa" && $1a19ad51aa7d708b$var$isMobile() && (0, $b86f4cc7a79985a5$export$a968ef38a9c25187)(url)) (0, $b86f4cc7a79985a5$export$8b96f5ffd2552cf5)({
                    url: url,
                    consultant: consultant,
                    theme: theme,
                    lang: lang
                });
            }
        }
    }, theme, lang, url);
}
function $1a19ad51aa7d708b$var$enlargePopup({ delay: delay }) {
    if (window.BH.popupVideoUrl !== null) (0, $11990f87f0d79dff$export$ae6c4758b5042ef8)();
    $1a19ad51aa7d708b$var$timer = setTimeout(function() {
        const widget = document.querySelector(".beratungshero--root .beratungshero--popup");
        if (widget) {
            // Show popup
            const enlarged = (0, (/*@__PURE__*/$parcel$interopDefault($0e53695f56cec54b$exports))).get($1a19ad51aa7d708b$var$POPUP_ENLARGED_COOKIE_NAME);
            if (!enlarged && !window.BH.widgetBig) {
                (0, $11990f87f0d79dff$export$cfae72848eff8ed2)();
                widget.style.transform = "scale(1)";
                const avatar = document.querySelector(".beratungshero--avatar");
                avatar.querySelector(".beratungshero--avatar-img").classList.remove("beratungshero--avatar-pulse");
                window.BH.widgetClosed = false;
                (0, (/*@__PURE__*/$parcel$interopDefault($0e53695f56cec54b$exports))).set($1a19ad51aa7d708b$var$POPUP_ENLARGED_COOKIE_NAME, true);
                window.BH.widgetBig = true;
            }
        }
    }, delay);
}
let $1a19ad51aa7d708b$var$currentUrl = document.location.href.split("#")[0];
let $1a19ad51aa7d708b$var$stylesAdded = false;
if (!window.BH) window.BH = {
    widgetBig: false,
    widgetClosed: true
};
window.BH["renderSticker"] = (0, $73827848afd8cfc5$export$2e2bcd8739ae039);
window.BH["renderBanner"] = (0, $7f261094d30e6c24$export$2e2bcd8739ae039);
window.BH["renderWishlistBanner"] = (0, $5eb86eb81955a43c$export$2e2bcd8739ae039);
let $1a19ad51aa7d708b$var$timer;
function $1a19ad51aa7d708b$var$getParam(url, name) {
    return new URL(url).searchParams.get(name);
}
function $1a19ad51aa7d708b$var$checkIfEnabled(callback, theme, lang, url) {
    const handleWidgetEnabledResponse = (data)=>{
        const { enabled: enabled, error: error, booking: booking, bookingLink: bookingLink, duringOfficeHours: duringOfficeHours, consultantAvailable: consultantAvailable, consultant: consultant, landingPageUrl: landingPageUrl, tenant: tenant } = data;
        let throttled;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0e53695f56cec54b$exports))).get($1a19ad51aa7d708b$var$THROTTLED_COOKIE_NAME) === undefined) {
            throttled = Math.floor(Math.random() * 100) > tenant.throttlingRatio * 100;
            (0, (/*@__PURE__*/$parcel$interopDefault($0e53695f56cec54b$exports))).set($1a19ad51aa7d708b$var$THROTTLED_COOKIE_NAME, throttled);
        } else throttled = $1a19ad51aa7d708b$var$isThrottled();
        if (throttled) // don't call callback
        return;
        // todo better solution for landing pages
        let landingPageUrl2;
        if (landingPageUrl) landingPageUrl2 = landingPageUrl.replace(/\/de\//, `/${lang}/`);
        else landingPageUrl2 = tenant.landingPageUrls[lang];
        if ((0, $bd64aa99694b6ef2$export$bfb231a5a6aca5de)(theme)) return;
        if (!error && enabled) {
            if (duringOfficeHours && consultantAvailable) {
                $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.show");
                $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show");
                if (tenant.name === "sportxx" || tenant.name === "sportx") {
                    if (url.match(/\/bekleidung-schuhe\/bekleidung/) || url.match(/\/ausruestung\/trekking-zubehoer/) || url.match(/\/ausruestung\/rucksaecke/) || (0, $330d32d652193a23$export$8bcfff33a6c98fa4)(url, [
                        "bekleidung-schuhe/bekleidung",
                        "ausruestung/trekking-zubehoer",
                        "ausruestung/rucksaecke"
                    ])) {
                        console.log("log optimize outdoor");
                        $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show.outdoor");
                    } else if (url.match(/\/sports\/fitness/) || url.match(/\/ausruestung\/fitness/) || (0, $330d32d652193a23$export$8bcfff33a6c98fa4)(url, [
                        "sports/fitness",
                        "ausruestung/fitness-zubehoer",
                        "ausruestung/fitnessgeraete"
                    ])) {
                        console.log("log optimize fitness");
                        $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show.fitness");
                    } else if (url.match(/\/sports\/running/) || (0, $330d32d652193a23$export$8bcfff33a6c98fa4)(url, [
                        "sports/running"
                    ])) {
                        console.log("log optimize running");
                        $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show.running");
                    } else if (url.match(/\/sports\/ski/) || url.match(/\/ausruestung\/ski/) || url.match(/\/ausruestung\/snow/) || (0, $330d32d652193a23$export$8bcfff33a6c98fa4)(url, [
                        "ausruestung/langlaufschuhe",
                        "ausruestung/langlaufski",
                        "ausruestung/schlitten-bobs",
                        "ausruestung/schlittschuhe",
                        "ausruestung/schneeschuhe",
                        "ausruestung/ski",
                        "ausruestung/skischuhe",
                        "ausruestung/snowboard",
                        "ausruestung/snowboard-bindungen",
                        "ausruestung/snowboardschuhe",
                        "ausruestung/stoecke",
                        "ausruestung/tourenzubehoer"
                    ])) {
                        console.log("log optimize ski");
                        $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show.ski");
                    } else $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.call.show.neutral");
                }
                callback(consultant, false, bookingLink, landingPageUrl2, tenant);
            } else {
                if (booking && lang !== "it") {
                    $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.widget.show");
                    callback(null, true, bookingLink, landingPageUrl2, tenant);
                } else if (tenant.fallbackTenantName) {
                    $1a19ad51aa7d708b$var$from = tenant.name;
                    (0, $9638d45de83d5cf1$export$85fae2512280f40b)(tenant.fallbackTenantName, lang).then((res)=>{
                        res.json().then(handleWidgetEnabledResponse);
                    });
                } else {
                    // remove widget
                    const root = document.querySelector(".beratungshero--root");
                    if (root) root.remove();
                }
            }
        }
    };
    (0, $9638d45de83d5cf1$export$85fae2512280f40b)(theme, lang).then((res)=>{
        res.json().then(handleWidgetEnabledResponse);
    });
}
function $1a19ad51aa7d708b$var$getThemeAndLang(url) {
    if (url.match(/klubschule.ch/)) return {
        theme: "klubschule",
        lang: "de"
    };
    else if (url.match(/ecole-club.ch/)) return {
        theme: "klubschule",
        lang: "fr"
    };
    else if (url.match(/scuola-club.ch/)) return {
        theme: "klubschule",
        lang: "it"
    };
    const match = url.match(/(bikeworld|doitgarden|micasa|melectronics|sportx).ch\/(de|fr|it)/);
    if (match) {
        const [, theme, lang] = match;
        if ($1a19ad51aa7d708b$var$showMiocolorWidget(url, theme, lang)) return {
            theme: "miocolor",
            lang: lang
        };
        // navigator.language references Browser UI language instead of
        // Accept-Language header in Chrome & Edge Chromium
        // https://caniuse.com/mdn-api_navigatorlanguage_language
        if ((navigator.language || "").startsWith("en")) {
            $1a19ad51aa7d708b$var$logOptimizeEvent("optimize.browser.en");
            if (!!window.BH.englishJourney // is set by Optimize
            ) return {
                theme: theme,
                lang: "en"
            };
        }
        return {
            theme: theme,
            lang: lang
        };
    }
    return {
        theme: null,
        lang: null
    };
}
let $1a19ad51aa7d708b$var$delay = window.BH.enlargePopupDelayProduct || $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_PRODUCT;
function $1a19ad51aa7d708b$var$checkIfShown() {
    let url = $1a19ad51aa7d708b$var$currentUrl;
    let delay = window.BH.enlargePopupDelayProduct || $1a19ad51aa7d708b$var$ENLARGE_POPUP_DELAY_PRODUCT;
    if (url.match("localhost") || url.match("ngrok")) {
        url = "https://www.sportx.ch/de/f/aktionensd?q=%3Arelevance%3Aspecial%3AAktion";
        // "https://www.melectronics.ch/de/p/794687500000/samsung-galaxy-a13-128gb-black";
        //"https://www.bikeworld.ch/de?gclid=CjwKCAjw4ayUBhA4EiwATWyBrpbiEp7R2TQpC2_tC2xH2j3voqDHIMp2aPhKmd58WipqFnDylBjFzhoCPPcQAvD_BwE&gclsrc=aw.ds";
        delay = 1000;
        if (!window.dataLayer) window.dataLayer = [];
        window.dataLayer.push({
            event: "productImpression",
            ecommerce: {
                currencyCode: "CHF",
                recommTool: "custom",
                productCount: 65,
                impressions: [
                    {
                        uniqueProductId: "794687500000",
                        price: "189",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: true,
                        position: 1,
                        productURL: "https://www.melectronics.ch/de/p/794687500000/samsung-galaxy-a13-128gb-black",
                        productImageURL: "https://image.migros.ch/original/eba29be15be85e1e38e404909b709dde72c3e4d2/samsung-galaxy-a13-128gb-black-smartphone.jpg",
                        name: "Galaxy A13 128GB Black",
                        id: "794687500000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        oldPrice: "209",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794687400000",
                        price: "369",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 2,
                        productURL: "https://www.melectronics.ch/de/p/794687400000/samsung-galaxy-a33-5g-128gb-awesome-black",
                        productImageURL: "https://image.migros.ch/original/666ad40dc9535b2a90e6beff80ffc241da69dd88/samsung-galaxy-a33-5g-128gb-awesome-black-smartphone.jpg",
                        name: "Galaxy A33 5G 128GB Awesome Black",
                        id: "794687400000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794687300000",
                        price: "449",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 3,
                        productURL: "https://www.melectronics.ch/de/p/794687300000/samsung-galaxy-a53-5g-128gb-awesome-black",
                        productImageURL: "https://image.migros.ch/original/cc92b9347c2fc652dd7c065cde2435e941bc3c7f/samsung-galaxy-a53-5g-128gb-awesome-black-smartphone.jpg",
                        name: "Galaxy A53 5G 128GB Awesome Black",
                        id: "794687300000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794675000000",
                        price: "549",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 4,
                        productURL: "https://www.melectronics.ch/de/p/794675000000/samsung-galaxy-s21-fe-5g-128gb-graphite",
                        productImageURL: "https://image.migros.ch/original/2534d1f3f83af8b957efa673b450363cc35480ff/samsung-galaxy-s21-fe-5g-128gb-graphite-smartphone.jpg",
                        name: "Galaxy S21 FE 5G 128GB Graphite",
                        id: "794675000000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    },
                    {
                        uniqueProductId: "794683600000",
                        price: "749",
                        category: "melectronics/telefonie-navigation/smartphone",
                        variant: "standard",
                        discountType: false,
                        position: 5,
                        productURL: "https://www.melectronics.ch/de/p/794683600000/samsung-galaxy-s22-128gb-phantom-black",
                        productImageURL: "https://image.migros.ch/original/32d222db7eb1f6fe84eb37542625859890458846/samsung-galaxy-s22-128gb-phantom-black-smartphone.jpg",
                        name: "Galaxy S22 128GB Phantom Black",
                        id: "794683600000",
                        brand: "Samsung",
                        bossNumber: "240736283005",
                        productType: "Smartphone",
                        list: "kategorieseite",
                        listinfo: "3421317829 samsung"
                    }
                ]
            },
            "gtm.uniqueEventId": 25
        });
    }
    const isWebRTCSupported = $1a19ad51aa7d708b$var$supportsWebRTC();
    if (!isWebRTCSupported) return;
    // don't show widget for consultants
    if ($1a19ad51aa7d708b$var$getParam(url, "hidewidget") === "true") return;
    const utm_campaign = $1a19ad51aa7d708b$var$getParam(url, "utm_campaign");
    // Bei Aufforderung für Bewertung nach Kauf, Widget nicht anzeigen
    if (utm_campaign && utm_campaign.toLowerCase().startsWith("kun-01")) return;
    const { theme: theme, lang: lang } = $1a19ad51aa7d708b$var$getThemeAndLang(url);
    console.log("theme", theme, "lang", lang);
    if (!theme) return;
    // logEvent(variant === 1 ? "POPUP_VARIANT_A" : "POPUP_VARIANT_B");
    $1a19ad51aa7d708b$var$handlePageChange({
        url: url,
        delay: delay,
        theme: theme,
        lang: lang
    });
    setInterval(function() {
        if (document.location.href.split("#")[0] !== $1a19ad51aa7d708b$var$currentUrl) {
            $1a19ad51aa7d708b$var$currentUrl = document.location.href.split("#")[0];
            // clear previous trigger to enlarge popup
            clearTimeout($1a19ad51aa7d708b$var$timer);
            $1a19ad51aa7d708b$var$handlePageChange({
                url: $1a19ad51aa7d708b$var$currentUrl,
                delay: delay,
                theme: theme,
                lang: lang
            });
        }
    }, 1000);
}
$1a19ad51aa7d708b$var$checkIfShown();
/*
 * Returns 1 or 2
 * 1: Popup Variante A "grosses Pop Up"
 * 2: Popup Variante B "kleines Pop Up"
 */ function $1a19ad51aa7d708b$var$getVariant(theme) {
    if (!$1a19ad51aa7d708b$var$isMobile() || theme === "melectronics") return 1;
    else return 2;
}
function $1a19ad51aa7d708b$var$isMobile() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return vw <= 640;
}
function $1a19ad51aa7d708b$var$isThrottled() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0e53695f56cec54b$exports))).get($1a19ad51aa7d708b$var$THROTTLED_COOKIE_NAME) === "true";
}
function $1a19ad51aa7d708b$var$updatePopupPrimaryButtonShopUrl() {
    const popupPrimaryButton = document.querySelector(".js-beratungshero-popup-primary-button");
    if (popupPrimaryButton) {
        const currentLink = popupPrimaryButton.getAttribute("href");
        const newLink = currentLink.replace(/&url=.*&consultantId=/, `&url=${$1a19ad51aa7d708b$var$getShopUrl()}&consultantId=`);
        popupPrimaryButton.setAttribute("href", newLink.replace(/&richrelevanceFeed=.*/, ""));
    }
}
function $1a19ad51aa7d708b$var$updateRichrelevanceFeed() {
    const richrelevanceFeed = (0, $0b060e8a1ef8f2b3$export$b33daf2836bb52dc)();
    if (richrelevanceFeed) {
        const popupPrimaryButton = document.querySelector(".js-beratungshero-popup-primary-button");
        if (popupPrimaryButton) {
            const currentLink = popupPrimaryButton.getAttribute("href");
            let newLink;
            if (currentLink.includes("&richrelevanceFeed=")) newLink = currentLink.replace(/&richrelevanceFeed=.*/, `&richrelevanceFeed=${richrelevanceFeed}`);
            else newLink = `${currentLink}&richrelevanceFeed=${richrelevanceFeed}`;
            popupPrimaryButton.setAttribute("href", newLink);
        }
    }
}
function $1a19ad51aa7d708b$var$getShopUrl() {
    let shopUrl = document.location.href.split("#")[0];
    if (shopUrl.match("localhost") || shopUrl.match("ngrok")) shopUrl = "https://www.klubschule.ch/Services/Beratung-und-Kontakt/Live-Videoberatung"; //https://qual-www.sportx.ch/de/p/405750100000/diener";
    return shopUrl;
}
function $1a19ad51aa7d708b$var$logOptimizeEvent(eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName
    });
}
function $1a19ad51aa7d708b$var$showMiocolorWidget(url, theme, lang) {
    return theme === "doitgarden" && (url.match(/\/(miocolor)/) || url.match(/\/(elle-decoration)/) || url.match(/\/(malen)/) || url.match(/\/(schoener-wohnen)/) || url.match(/\/(dupli-color)/) || url.match(/\/(d-c-fix)/) || url.match(/\/(color-expert)/) || url.match(/\/(produktfinder-malen)/) || url.match(/\/(farbmisch-service)/) || url.match(/q=farbe/) || url.match(/q=wand%20farben/) || url.match(/malen/) || url.match(/q=lack/) || (0, $330d32d652193a23$export$92413a7c60d15e8a)(url, "malen")) && lang === "de";
}
function $1a19ad51aa7d708b$var$showSportxTouchpoints(theme, lang) {
    if (!document.querySelector(".js__beratungshero--sticker.beratungshero--sticker")) {
        const containerSticker = document.querySelector("#migros-beratungshero");
        if (containerSticker) {
            containerSticker.style.position = "relative";
            window.BH.renderSticker(containerSticker, {
                tenant: theme,
                lang: lang
            });
        }
    }
    if (!document.querySelector(".beratungshero--root.p-product-detail--item.p-product-detail--item__details.detail-navigation-section")) {
        const containerBanner = document.querySelector("#accordion-wrapper>div:nth-child(5)");
        if (containerBanner) window.BH.renderBanner(containerBanner, {
            tenant: theme,
            lang: lang
        });
    }
}
(()=>{
    const match = document.location.href.split("#")[0].match(/(bikeworld|doitgarden|micasa|melectronics|sportx).ch\/(de|fr|it)/);
    if (!match) return;
    const [, theme, lang] = match;
    if (theme === "sportx") {
        let previousUrl = "";
        const observer = new MutationObserver(function(mutations) {
            if (location.href !== previousUrl) {
                previousUrl = location.href;
                $1a19ad51aa7d708b$var$showSportxTouchpoints(theme, lang);
            }
        });
        const config = {
            subtree: true,
            childList: true
        };
        observer.observe(document, config);
    }
})();


//# sourceMappingURL=index.bf08f0dd.js.map
